//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ApiBaseClass {
  protected getBaseUrl = (defaultUrl: string, baseUrl: string | undefined) => {
    return process.env.REACT_APP_API_BASE_URL || defaultUrl;
  };
}

export class MarketplaceAPI extends ApiBaseClass {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://api-qa.mybasepay.com", baseUrl);
    }

    /**
     * Registration
     * @param body (optional) 
     * @return Success
     */
    createNewAccount(body: RegMarketplaceModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/account/registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewAccount(_response);
        });
    }

    protected processCreateNewAccount(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get profile types
     * @return Success
     */
    getProfileTypes(): Promise<ProfileTypeEnum[]> {
        let url_ = this.baseUrl + "/marketplace/account/profile-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProfileTypes(_response);
        });
    }

    protected processGetProfileTypes(response: Response): Promise<ProfileTypeEnum[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileTypeEnum[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileTypeEnum[]>(null as any);
    }

    /**
     * Create initial profile
     * @param body (optional) 
     * @return Success
     */
    setupInitialProfile(body: InitialProfileRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/account/initial-profile/setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetupInitialProfile(_response);
        });
    }

    protected processSetupInitialProfile(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get my user profile
     * @return Success
     */
    getMyUserProfile(): Promise<MarketplaceUserModel> {
        let url_ = this.baseUrl + "/marketplace/account/user/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyUserProfile(_response);
        });
    }

    protected processGetMyUserProfile(response: Response): Promise<MarketplaceUserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketplaceUserModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketplaceUserModel>(null as any);
    }

    /**
     * Get My Company profile
     * @return Success
     */
    getMyCompanyProfile(): Promise<CompanyProfileEditViewModel> {
        let url_ = this.baseUrl + "/marketplace/account/company/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyCompanyProfile(_response);
        });
    }

    protected processGetMyCompanyProfile(response: Response): Promise<CompanyProfileEditViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyProfileEditViewModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyProfileEditViewModel>(null as any);
    }

    /**
     * Update Company profile
     * @param body (optional) 
     * @return No Content
     */
    updateMyCompanyProfile(body: CompanyProfileEditModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/account/company/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMyCompanyProfile(_response);
        });
    }

    protected processUpdateMyCompanyProfile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update company logo image
     * @return No Content
     */
    updateMyCompanyLogoImage(body: string): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/account/company/logo-image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMyCompanyLogoImage(_response);
        });
    }

    protected processUpdateMyCompanyLogoImage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete company logo image
     * @return No Content
     */
    deleteMyCompanyLogoImage(body: string): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/account/company/logo-image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteMyCompanyLogoImage(_response);
        });
    }

    protected processDeleteMyCompanyLogoImage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update company background image
     * @return No Content
     */
    updateMyCompanyBackgroundImage(body: string): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/account/company/background-image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMyCompanyBackgroundImage(_response);
        });
    }

    protected processUpdateMyCompanyBackgroundImage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete company background image
     * @return No Content
     */
    deleteMyCompanyBackgroundImage(body: string): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/account/company/background-image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteMyCompanyBackgroundImage(_response);
        });
    }

    protected processDeleteMyCompanyBackgroundImage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Registration
     * @param body (optional) 
     * @return Success
     */
    createInvitedUserAccount(body: RegInvitedUserModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/account/registration-invited-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateInvitedUserAccount(_response);
        });
    }

    protected processCreateInvitedUserAccount(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Invite user
     * @param body (optional) 
     * @return Success
     */
    inviteUser(body: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/account/invite-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInviteUser(_response);
        });
    }

    protected processInviteUser(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get Invited User Detail
     * @param email (optional) 
     * @return Success
     */
    getInvitedUserDetail(email: string | undefined): Promise<InvitedUserDetailEntity> {
        let url_ = this.baseUrl + "/marketplace/account/invited-user-detail?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvitedUserDetail(_response);
        });
    }

    protected processGetInvitedUserDetail(response: Response): Promise<InvitedUserDetailEntity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvitedUserDetailEntity;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvitedUserDetailEntity>(null as any);
    }

    /**
     * Get list of submitted partner invitation
     * @param status (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getSubmittedPartnerInvitation(status: InvitationStatusFilterEnum | undefined, pageNumber: number | undefined): Promise<PagedPartnerInvitationResponse> {
        let url_ = this.baseUrl + "/marketplace/account/company/partner-invitations/submitted?";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubmittedPartnerInvitation(_response);
        });
    }

    protected processGetSubmittedPartnerInvitation(response: Response): Promise<PagedPartnerInvitationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedPartnerInvitationResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedPartnerInvitationResponse>(null as any);
    }

    /**
     * Add new partner invitation
     * @param body (optional) 
     * @return No Content
     */
    addNewPartnerInvitation(body: AddMyCompanyPartnerRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/account/company/partner-invitations/submitted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewPartnerInvitation(_response);
        });
    }

    protected processAddNewPartnerInvitation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get list of received partner invitation
     * @param status (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getReceivedPartnerInvitation(status: InvitationStatusFilterEnum | undefined, pageNumber: number | undefined): Promise<PagedPartnerInvitationResponse> {
        let url_ = this.baseUrl + "/marketplace/account/company/partner-invitations/received?";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReceivedPartnerInvitation(_response);
        });
    }

    protected processGetReceivedPartnerInvitation(response: Response): Promise<PagedPartnerInvitationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedPartnerInvitationResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedPartnerInvitationResponse>(null as any);
    }

    /**
     * Set new status for received partner invitation
     * @param invitationId Invitation UUID
     * @param body (optional) 
     * @return No Content
     */
    setReceivedPartnerInvitationStatus(invitationId: string, body: ReceivedPartnerInvitationStatusRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/account/company/partner-invitations/received/{invitationId}/status";
        if (invitationId === undefined || invitationId === null)
            throw new globalThis.Error("The parameter 'invitationId' must be defined.");
        url_ = url_.replace("{invitationId}", encodeURIComponent("" + invitationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetReceivedPartnerInvitationStatus(_response);
        });
    }

    protected processSetReceivedPartnerInvitationStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get list of company partners
     * @param pageNumber (optional) 
     * @param isPreferred (optional) 
     * @return Success
     */
    getMyCompanyPartners(pageNumber: number | undefined, isPreferred: boolean | undefined): Promise<PagedPartnersResponse> {
        let url_ = this.baseUrl + "/marketplace/account/company/partners?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (isPreferred === null)
            throw new globalThis.Error("The parameter 'isPreferred' cannot be null.");
        else if (isPreferred !== undefined)
            url_ += "IsPreferred=" + encodeURIComponent("" + isPreferred) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyCompanyPartners(_response);
        });
    }

    protected processGetMyCompanyPartners(response: Response): Promise<PagedPartnersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedPartnersResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedPartnersResponse>(null as any);
    }

    /**
     * Get list of all company partners
     * @return Success
     */
    getAllMyCompanyPartnersDictionary(): Promise<PartnerSelectModel[]> {
        let url_ = this.baseUrl + "/marketplace/account/company/allpartnersfordropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllMyCompanyPartnersDictionary(_response);
        });
    }

    protected processGetAllMyCompanyPartnersDictionary(response: Response): Promise<PartnerSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartnerSelectModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartnerSelectModel[]>(null as any);
    }

    /**
     * Add new external partner invitation
     * @param body (optional) 
     * @return No Content
     */
    addNewExternalPartnerInvitation(body: AddMyCompanyExternalRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/account/company/external-invitations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewExternalPartnerInvitation(_response);
        });
    }

    protected processAddNewExternalPartnerInvitation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get fill data for registration new account
     * @param invitationId Invitation UUID
     * @return Success
     */
    getRegDataForExternalPartnerInvitation(invitationId: string): Promise<RegDataForExternalInvitationResponse> {
        let url_ = this.baseUrl + "/marketplace/account/company/external-invitations/{invitationId}/registration-data";
        if (invitationId === undefined || invitationId === null)
            throw new globalThis.Error("The parameter 'invitationId' must be defined.");
        url_ = url_.replace("{invitationId}", encodeURIComponent("" + invitationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRegDataForExternalPartnerInvitation(_response);
        });
    }

    protected processGetRegDataForExternalPartnerInvitation(response: Response): Promise<RegDataForExternalInvitationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegDataForExternalInvitationResponse;
            return result200;
            });
        } else if (status === 418) {
            return response.text().then((_responseText) => {
            let result418: any = null;
            result418 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Client Error", status, _responseText, _headers, result418);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegDataForExternalInvitationResponse>(null as any);
    }

    /**
     * Mark Partner Preferred
     * @param targetCompanyId (optional) 
     * @return Success
     */
    markPartnerPreferred(targetCompanyId: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/marketplace/account/company/markpartnerpreferred?";
        if (targetCompanyId === null)
            throw new globalThis.Error("The parameter 'targetCompanyId' cannot be null.");
        else if (targetCompanyId !== undefined)
            url_ += "targetCompanyId=" + encodeURIComponent("" + targetCompanyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkPartnerPreferred(_response);
        });
    }

    protected processMarkPartnerPreferred(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Unmark Partner Preferred
     * @param targetCompanyId (optional) 
     * @return Success
     */
    unmarkPartnerPreferred(targetCompanyId: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/marketplace/account/company/unmarkpartnerpreferred?";
        if (targetCompanyId === null)
            throw new globalThis.Error("The parameter 'targetCompanyId' cannot be null.");
        else if (targetCompanyId !== undefined)
            url_ += "targetCompanyId=" + encodeURIComponent("" + targetCompanyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnmarkPartnerPreferred(_response);
        });
    }

    protected processUnmarkPartnerPreferred(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get My Jobs
     * @param pageNumber (optional) 
     * @param publishStatus (optional) 
     * @param sortField (optional) 
     * @param sortType (optional) 
     * @param industryIds (optional) 
     * @param cityIds (optional) 
     * @param departmentIds (optional) 
     * @return Success
     */
    getmyjobs(pageNumber: number | undefined, publishStatus: JobPublishStatus | undefined, sortField: JobSortFieldEnum | undefined, sortType: SortingEnum | undefined, industryIds: number[] | undefined, cityIds: number[] | undefined, departmentIds: string[] | undefined): Promise<JobDetailListModel> {
        let url_ = this.baseUrl + "/marketplace/account/job/getmyjobs?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (publishStatus === null)
            throw new globalThis.Error("The parameter 'publishStatus' cannot be null.");
        else if (publishStatus !== undefined)
            url_ += "PublishStatus=" + encodeURIComponent("" + publishStatus) + "&";
        if (sortField === null)
            throw new globalThis.Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortType === null)
            throw new globalThis.Error("The parameter 'sortType' cannot be null.");
        else if (sortType !== undefined)
            url_ += "SortType=" + encodeURIComponent("" + sortType) + "&";
        if (industryIds === null)
            throw new globalThis.Error("The parameter 'industryIds' cannot be null.");
        else if (industryIds !== undefined)
            industryIds && industryIds.forEach(item => { url_ += "IndustryIds=" + encodeURIComponent("" + item) + "&"; });
        if (cityIds === null)
            throw new globalThis.Error("The parameter 'cityIds' cannot be null.");
        else if (cityIds !== undefined)
            cityIds && cityIds.forEach(item => { url_ += "CityIds=" + encodeURIComponent("" + item) + "&"; });
        if (departmentIds === null)
            throw new globalThis.Error("The parameter 'departmentIds' cannot be null.");
        else if (departmentIds !== undefined)
            departmentIds && departmentIds.forEach(item => { url_ += "DepartmentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetmyjobs(_response);
        });
    }

    protected processGetmyjobs(response: Response): Promise<JobDetailListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobDetailListModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobDetailListModel>(null as any);
    }

    /**
     * Get Cities by Job status
     * @param publishStatus (optional) 
     * @return Success
     */
    getCitiesForMyJobsByStatus(publishStatus: JobPublishStatus | undefined): Promise<CityEntity[]> {
        let url_ = this.baseUrl + "/marketplace/account/job/cities?";
        if (publishStatus === null)
            throw new globalThis.Error("The parameter 'publishStatus' cannot be null.");
        else if (publishStatus !== undefined)
            url_ += "publishStatus=" + encodeURIComponent("" + publishStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCitiesForMyJobsByStatus(_response);
        });
    }

    protected processGetCitiesForMyJobsByStatus(response: Response): Promise<CityEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CityEntity[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityEntity[]>(null as any);
    }

    /**
     * Get Industries by Job status
     * @param publishStatus (optional) 
     * @return Success
     */
    getIndustriesForMyJobsByStatus(publishStatus: JobPublishStatus | undefined): Promise<IndustryEntity[]> {
        let url_ = this.baseUrl + "/marketplace/account/job/industries?";
        if (publishStatus === null)
            throw new globalThis.Error("The parameter 'publishStatus' cannot be null.");
        else if (publishStatus !== undefined)
            url_ += "publishStatus=" + encodeURIComponent("" + publishStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIndustriesForMyJobsByStatus(_response);
        });
    }

    protected processGetIndustriesForMyJobsByStatus(response: Response): Promise<IndustryEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IndustryEntity[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IndustryEntity[]>(null as any);
    }

    /**
     * Get Partners Jobs
     * @param pageNumber (optional) 
     * @param sortType (optional) 
     * @param industryIds (optional) 
     * @param cityIds (optional) 
     * @param companyIds (optional) 
     * @param isAssignedToMe (optional) 
     * @return Success
     */
    getpartnersjobs(pageNumber: number | undefined, sortType: SortingEnum | undefined, industryIds: number[] | undefined, cityIds: number[] | undefined, companyIds: string[] | undefined, isAssignedToMe: boolean | undefined): Promise<JobDetailListModel> {
        let url_ = this.baseUrl + "/marketplace/account/job/getpartnersjobs?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (sortType === null)
            throw new globalThis.Error("The parameter 'sortType' cannot be null.");
        else if (sortType !== undefined)
            url_ += "SortType=" + encodeURIComponent("" + sortType) + "&";
        if (industryIds === null)
            throw new globalThis.Error("The parameter 'industryIds' cannot be null.");
        else if (industryIds !== undefined)
            industryIds && industryIds.forEach(item => { url_ += "IndustryIds=" + encodeURIComponent("" + item) + "&"; });
        if (cityIds === null)
            throw new globalThis.Error("The parameter 'cityIds' cannot be null.");
        else if (cityIds !== undefined)
            cityIds && cityIds.forEach(item => { url_ += "CityIds=" + encodeURIComponent("" + item) + "&"; });
        if (companyIds === null)
            throw new globalThis.Error("The parameter 'companyIds' cannot be null.");
        else if (companyIds !== undefined)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        if (isAssignedToMe === null)
            throw new globalThis.Error("The parameter 'isAssignedToMe' cannot be null.");
        else if (isAssignedToMe !== undefined)
            url_ += "IsAssignedToMe=" + encodeURIComponent("" + isAssignedToMe) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetpartnersjobs(_response);
        });
    }

    protected processGetpartnersjobs(response: Response): Promise<JobDetailListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobDetailListModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobDetailListModel>(null as any);
    }

    /**
     * Get Cities for Partners Jobs
     * @return Success
     */
    getCitiesForPartnersJobs(): Promise<CityEntity[]> {
        let url_ = this.baseUrl + "/marketplace/account/job/partners-cities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCitiesForPartnersJobs(_response);
        });
    }

    protected processGetCitiesForPartnersJobs(response: Response): Promise<CityEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CityEntity[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityEntity[]>(null as any);
    }

    /**
     * Get Industries for Partners Jobs
     * @return Success
     */
    getIndustriesForPartnersJobs(): Promise<IndustryEntity[]> {
        let url_ = this.baseUrl + "/marketplace/account/job/partners-industries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIndustriesForPartnersJobs(_response);
        });
    }

    protected processGetIndustriesForPartnersJobs(response: Response): Promise<IndustryEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IndustryEntity[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IndustryEntity[]>(null as any);
    }

    /**
     * Get companies for Partners Jobs
     * @return Success
     */
    getCompaniesForPartnersJobs(): Promise<CompanyMiniModel[]> {
        let url_ = this.baseUrl + "/marketplace/account/job/assigned-jobs/companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCompaniesForPartnersJobs(_response);
        });
    }

    protected processGetCompaniesForPartnersJobs(response: Response): Promise<CompanyMiniModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyMiniModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyMiniModel[]>(null as any);
    }

    /**
     * Candidate Preferences
     * @return Success
     */
    getCandidatePreferences(): Promise<CandidatePreferencesResponseModel> {
        let url_ = this.baseUrl + "/marketplace/account/settings/candidate-preferences";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCandidatePreferences(_response);
        });
    }

    protected processGetCandidatePreferences(response: Response): Promise<CandidatePreferencesResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidatePreferencesResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CandidatePreferencesResponseModel>(null as any);
    }

    /**
     * Candidate Preferences
     * @param body (optional) 
     * @return Success
     */
    createCandidatePreferences(body: CandidatePreferencesRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/account/settings/candidate-preferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCandidatePreferences(_response);
        });
    }

    protected processCreateCandidatePreferences(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Candidate Preferences
     * @param body (optional) 
     * @return Success
     */
    updateCandidatePreferences(body: CandidatePreferencesRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/account/settings/candidate-preferences/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCandidatePreferences(_response);
        });
    }

    protected processUpdateCandidatePreferences(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Submit candidate
     * @param isOwnCandidate (optional) 
     * @param body (optional) 
     * @return Success
     */
    submitCandidate(isOwnCandidate: boolean | undefined, body: SubmitCandidateModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/candidates/submit?";
        if (isOwnCandidate === null)
            throw new globalThis.Error("The parameter 'isOwnCandidate' cannot be null.");
        else if (isOwnCandidate !== undefined)
            url_ += "isOwnCandidate=" + encodeURIComponent("" + isOwnCandidate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubmitCandidate(_response);
        });
    }

    protected processSubmitCandidate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Submit company candidate
     * @param body (optional) 
     * @return Success
     */
    submitCompanyCandidate(body: SubmitCompanyCandidateModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/candidates/submit-company-candidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubmitCompanyCandidate(_response);
        });
    }

    protected processSubmitCompanyCandidate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get submitted duplicated candidates by candidate id
     * @param pageNumber (optional) 
     * @param jobId (optional) 
     * @param candidateId (optional) 
     * @return Success
     */
    getSubmittedDuplicatedCandidatesById(pageNumber: number | undefined, jobId: string | undefined, candidateId: string | undefined): Promise<PagedJobDuplicatedCandidateResponse> {
        let url_ = this.baseUrl + "/marketplace/candidates/submitted/duplicates-by-id?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        if (candidateId === null)
            throw new globalThis.Error("The parameter 'candidateId' cannot be null.");
        else if (candidateId !== undefined)
            url_ += "candidateId=" + encodeURIComponent("" + candidateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubmittedDuplicatedCandidatesById(_response);
        });
    }

    protected processGetSubmittedDuplicatedCandidatesById(response: Response): Promise<PagedJobDuplicatedCandidateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedJobDuplicatedCandidateResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedJobDuplicatedCandidateResponse>(null as any);
    }

    /**
     * Get submitted duplicated candidates by candidate email
     * @param pageNumber (optional) 
     * @param jobId (optional) 
     * @param email (optional) 
     * @return Success
     */
    getSubmittedDuplicatedCandidatesByEmail(pageNumber: number | undefined, jobId: string | undefined, email: string | undefined): Promise<PagedJobDuplicatedCandidateResponse> {
        let url_ = this.baseUrl + "/marketplace/candidates/submitted/duplicates-by-email?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubmittedDuplicatedCandidatesByEmail(_response);
        });
    }

    protected processGetSubmittedDuplicatedCandidatesByEmail(response: Response): Promise<PagedJobDuplicatedCandidateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedJobDuplicatedCandidateResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedJobDuplicatedCandidateResponse>(null as any);
    }

    /**
     * Can Submit candidate
     * @param jobId (optional) 
     * @return Success
     */
    canSubmitCandidate(jobId: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/marketplace/candidates/can-submit-candidate?";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCanSubmitCandidate(_response);
        });
    }

    protected processCanSubmitCandidate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * ApproveStep
     * @param body (optional) 
     * @return Success
     */
    approveStep(body: JobCandidateApproveStepModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/candidates/approve-step";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApproveStep(_response);
        });
    }

    protected processApproveStep(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * setstages-all-jobCandidates
     * @return Success
     */
    setStagesForAllJobCandidates(): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/candidates/setstages-all-jobCandidates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetStagesForAllJobCandidates(_response);
        });
    }

    protected processSetStagesForAllJobCandidates(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get link and key for upload CV file
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @return Success
     */
    getCVUploadLink(document_ext: string): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/marketplace/candidates/cv-upload-link?";
        if (document_ext === undefined || document_ext === null)
            throw new globalThis.Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCVUploadLink(_response);
        });
    }

    protected processGetCVUploadLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Get link for download CV file
     * @param jobCandidateId Candidate UUID
     * @return Success
     */
    getCVDownloadLink(jobCandidateId: string): Promise<S3DownloadResponse> {
        let url_ = this.baseUrl + "/marketplace/candidates/{jobCandidateId}/cv-download-link";
        if (jobCandidateId === undefined || jobCandidateId === null)
            throw new globalThis.Error("The parameter 'jobCandidateId' must be defined.");
        url_ = url_.replace("{jobCandidateId}", encodeURIComponent("" + jobCandidateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCVDownloadLink(_response);
        });
    }

    protected processGetCVDownloadLink(response: Response): Promise<S3DownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3DownloadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3DownloadResponse>(null as any);
    }

    /**
     * Get received requests
     * @param pageNumber (optional) 
     * @param status (optional) 
     * @param companyIds (optional) 
     * @param jobIds (optional) 
     * @return Success
     */
    getCandidateReceivedRequests(pageNumber: number | undefined, status: CandidateStatusEnum | undefined, companyIds: string[] | undefined, jobIds: string[] | undefined): Promise<PagedJobCandidateResponse> {
        let url_ = this.baseUrl + "/marketplace/candidates/requests/received?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (companyIds === null)
            throw new globalThis.Error("The parameter 'companyIds' cannot be null.");
        else if (companyIds !== undefined)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        if (jobIds === null)
            throw new globalThis.Error("The parameter 'jobIds' cannot be null.");
        else if (jobIds !== undefined)
            jobIds && jobIds.forEach(item => { url_ += "JobIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCandidateReceivedRequests(_response);
        });
    }

    protected processGetCandidateReceivedRequests(response: Response): Promise<PagedJobCandidateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedJobCandidateResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedJobCandidateResponse>(null as any);
    }

    /**
     * Get received requests for corporate
     * @param pageNumber (optional) 
     * @param status (optional) 
     * @param companyIds (optional) 
     * @param jobIds (optional) 
     * @return Success
     */
    getCandidateReceivedRequestsCta(pageNumber: number | undefined, status: CandidateStatusEnum | undefined, companyIds: string[] | undefined, jobIds: string[] | undefined): Promise<PagedJobCandidateResponse> {
        let url_ = this.baseUrl + "/marketplace/candidates/requests/received-corporate-ta?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (companyIds === null)
            throw new globalThis.Error("The parameter 'companyIds' cannot be null.");
        else if (companyIds !== undefined)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        if (jobIds === null)
            throw new globalThis.Error("The parameter 'jobIds' cannot be null.");
        else if (jobIds !== undefined)
            jobIds && jobIds.forEach(item => { url_ += "JobIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCandidateReceivedRequestsCta(_response);
        });
    }

    protected processGetCandidateReceivedRequestsCta(response: Response): Promise<PagedJobCandidateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedJobCandidateResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedJobCandidateResponse>(null as any);
    }

    /**
     * Get submitted requests
     * @param pageNumber (optional) 
     * @param status (optional) 
     * @param companyIds (optional) 
     * @param jobIds (optional) 
     * @return Success
     */
    getCandidateSubmittedRequests(pageNumber: number | undefined, status: CandidateStatusEnum | undefined, companyIds: string[] | undefined, jobIds: string[] | undefined): Promise<PagedJobCandidateResponse> {
        let url_ = this.baseUrl + "/marketplace/candidates/requests/submitted?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (companyIds === null)
            throw new globalThis.Error("The parameter 'companyIds' cannot be null.");
        else if (companyIds !== undefined)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        if (jobIds === null)
            throw new globalThis.Error("The parameter 'jobIds' cannot be null.");
        else if (jobIds !== undefined)
            jobIds && jobIds.forEach(item => { url_ += "JobIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCandidateSubmittedRequests(_response);
        });
    }

    protected processGetCandidateSubmittedRequests(response: Response): Promise<PagedJobCandidateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedJobCandidateResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedJobCandidateResponse>(null as any);
    }

    /**
     * Get candidate details
     * @return Success
     */
    getJobCandidateDetails(jobCandidateId: string): Promise<JobCandidateResponse> {
        let url_ = this.baseUrl + "/marketplace/candidates/{jobCandidateId}/job-candidate";
        if (jobCandidateId === undefined || jobCandidateId === null)
            throw new globalThis.Error("The parameter 'jobCandidateId' must be defined.");
        url_ = url_.replace("{jobCandidateId}", encodeURIComponent("" + jobCandidateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobCandidateDetails(_response);
        });
    }

    protected processGetJobCandidateDetails(response: Response): Promise<JobCandidateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobCandidateResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobCandidateResponse>(null as any);
    }

    /**
     * Get job candidate duplicates
     * @param originalCandidateId (optional) 
     * @param jobId (optional) 
     * @param duplicateCandidateId (optional) 
     * @return Success
     */
    getJobCandidateDuplicates(originalCandidateId: string | undefined, jobId: string | undefined, duplicateCandidateId: string | undefined): Promise<JobCandidateResponse[]> {
        let url_ = this.baseUrl + "/marketplace/candidates/job-candidate/duplicates?";
        if (originalCandidateId === null)
            throw new globalThis.Error("The parameter 'originalCandidateId' cannot be null.");
        else if (originalCandidateId !== undefined)
            url_ += "originalCandidateId=" + encodeURIComponent("" + originalCandidateId) + "&";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        if (duplicateCandidateId === null)
            throw new globalThis.Error("The parameter 'duplicateCandidateId' cannot be null.");
        else if (duplicateCandidateId !== undefined)
            url_ += "duplicateCandidateId=" + encodeURIComponent("" + duplicateCandidateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobCandidateDuplicates(_response);
        });
    }

    protected processGetJobCandidateDuplicates(response: Response): Promise<JobCandidateResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobCandidateResponse[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobCandidateResponse[]>(null as any);
    }

    /**
     * Get candidate details
     * @param candidateId (optional) 
     * @return Success
     */
    getCandidateDetails(candidateId: string | undefined): Promise<CandidateResponseModel> {
        let url_ = this.baseUrl + "/marketplace/candidates/candidate?";
        if (candidateId === null)
            throw new globalThis.Error("The parameter 'candidateId' cannot be null.");
        else if (candidateId !== undefined)
            url_ += "candidateId=" + encodeURIComponent("" + candidateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCandidateDetails(_response);
        });
    }

    protected processGetCandidateDetails(response: Response): Promise<CandidateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CandidateResponseModel>(null as any);
    }

    /**
     * Get candidate CV file
     * @return Success
     */
    getCandidateCVFile(candidateId: string): Promise<ResourceDownloadResponse> {
        let url_ = this.baseUrl + "/marketplace/candidates/candidate-cv?";
        if (candidateId === undefined || candidateId === null)
            throw new globalThis.Error("The parameter 'candidateId' must be defined and cannot be null.");
        else
            url_ += "candidateId=" + encodeURIComponent("" + candidateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCandidateCVFile(_response);
        });
    }

    protected processGetCandidateCVFile(response: Response): Promise<ResourceDownloadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceDownloadResponse;
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceDownloadResponse>(null as any);
    }

    /**
     * Withdraw candidate request
     * @param body (optional) 
     * @return No Content
     */
    candidateRequestWithdraw(body: CandidateWithdrawRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/candidates/withdraw-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCandidateRequestWithdraw(_response);
        });
    }

    protected processCandidateRequestWithdraw(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get list of company
     * @return Success
     */
    getCompaniesBySubmittedCandidateRequests(): Promise<CompanyMiniModel[]> {
        let url_ = this.baseUrl + "/marketplace/candidates/companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCompaniesBySubmittedCandidateRequests(_response);
        });
    }

    protected processGetCompaniesBySubmittedCandidateRequests(response: Response): Promise<CompanyMiniModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyMiniModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyMiniModel[]>(null as any);
    }

    /**
     * Get list of jobs
     * @return Success
     */
    getJobsByReceivedCandidateRequests(): Promise<JobFilterModel[]> {
        let url_ = this.baseUrl + "/marketplace/candidates/jobs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobsByReceivedCandidateRequests(_response);
        });
    }

    protected processGetJobsByReceivedCandidateRequests(response: Response): Promise<JobFilterModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobFilterModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobFilterModel[]>(null as any);
    }

    /**
     * Create candidate
     * @param body (optional) 
     * @return Success
     */
    createCandidate(body: CandidateModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/candidates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCandidate(_response);
        });
    }

    protected processCreateCandidate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Edit candidate
     * @param body (optional) 
     * @return Success
     */
    editCandidate(body: CandidateModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/candidates/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditCandidate(_response);
        });
    }

    protected processEditCandidate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get my candidates
     * @param pageNumber (optional) 
     * @return Success
     */
    getMyCandidates(pageNumber: number | undefined): Promise<CandidatePagedResponseModel> {
        let url_ = this.baseUrl + "/marketplace/candidates/my-candidates?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyCandidates(_response);
        });
    }

    protected processGetMyCandidates(response: Response): Promise<CandidatePagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidatePagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CandidatePagedResponseModel>(null as any);
    }

    /**
     * Get companies by received candidates
     * @return Success
     */
    getReceivedCompaniesByReceivedCandidates(): Promise<CompanyMiniModel[]> {
        let url_ = this.baseUrl + "/marketplace/candidates/received-candidates-companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReceivedCompaniesByReceivedCandidates(_response);
        });
    }

    protected processGetReceivedCompaniesByReceivedCandidates(response: Response): Promise<CompanyMiniModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyMiniModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyMiniModel[]>(null as any);
    }

    /**
     * Get full my candidates
     * @return Success
     */
    getFullMyCandidatesList(): Promise<CandidateProfileModel[]> {
        let url_ = this.baseUrl + "/marketplace/candidates/my-candidates/full-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFullMyCandidatesList(_response);
        });
    }

    protected processGetFullMyCandidatesList(response: Response): Promise<CandidateProfileModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateProfileModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CandidateProfileModel[]>(null as any);
    }

    /**
     * Get company's list candidates short info by candidate email
     * @param pageNumber (optional) 
     * @param email (optional) 
     * @param candidateId (optional) 
     * @return Success
     */
    getCandidatesByEmail(pageNumber: number | undefined, email: string | undefined, candidateId: string | undefined): Promise<CandidateShortInfoResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/marketplace/candidates/list-by-email?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (candidateId === null)
            throw new globalThis.Error("The parameter 'candidateId' cannot be null.");
        else if (candidateId !== undefined)
            url_ += "CandidateId=" + encodeURIComponent("" + candidateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCandidatesByEmail(_response);
        });
    }

    protected processGetCandidatesByEmail(response: Response): Promise<CandidateShortInfoResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateShortInfoResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CandidateShortInfoResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Get company's list candidates short info by candidate email. Exclude candidate with this id in the returned list
     * @param pageNumber (optional) 
     * @param email (optional) 
     * @param candidateId (optional) 
     * @return Success
     */
    getCandidatesByEmailAndId(pageNumber: number | undefined, email: string | undefined, candidateId: string | undefined): Promise<CandidateShortInfoResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/marketplace/candidates/list-by-email-and-id?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (candidateId === null)
            throw new globalThis.Error("The parameter 'candidateId' cannot be null.");
        else if (candidateId !== undefined)
            url_ += "CandidateId=" + encodeURIComponent("" + candidateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCandidatesByEmailAndId(_response);
        });
    }

    protected processGetCandidatesByEmailAndId(response: Response): Promise<CandidateShortInfoResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateShortInfoResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CandidateShortInfoResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Create interview for candidate
     * @param body (optional) 
     * @return Created
     */
    createRequestInterview(body: RequestInterviewCandidateModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/candidates/interview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateRequestInterview(_response);
        });
    }

    protected processCreateRequestInterview(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Send reply to interview
     * @param body (optional) 
     * @return No Content
     */
    sendReplyToInterview(body: InterviewReplyRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/candidates/interview/reply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendReplyToInterview(_response);
        });
    }

    protected processSendReplyToInterview(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all candidateNotes for company
     * @param pageNumber (optional) 
     * @return Success
     */
    getCandidateNotesForCompany(candidateId: string, pageNumber: number | undefined): Promise<CandidateNoteDetailModelPagedResponseModel> {
        let url_ = this.baseUrl + "/marketplace/candidatenote/candidateNotes?";
        if (candidateId === undefined || candidateId === null)
            throw new globalThis.Error("The parameter 'candidateId' must be defined and cannot be null.");
        else
            url_ += "candidateId=" + encodeURIComponent("" + candidateId) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCandidateNotesForCompany(_response);
        });
    }

    protected processGetCandidateNotesForCompany(response: Response): Promise<CandidateNoteDetailModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateNoteDetailModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CandidateNoteDetailModelPagedResponseModel>(null as any);
    }

    /**
     * Create new candidateNote
     * @param body (optional) 
     * @return Success
     */
    createNewCandidateNote(body: CreateNewCandidateNoteRequest | undefined): Promise<CandidateNoteDetailModel> {
        let url_ = this.baseUrl + "/marketplace/candidatenote/candidateNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewCandidateNote(_response);
        });
    }

    protected processCreateNewCandidateNote(response: Response): Promise<CandidateNoteDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateNoteDetailModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CandidateNoteDetailModel>(null as any);
    }

    /**
     * Delete candidateNote
     * @return Success
     */
    deleteCandidateNoteById(candidateNoteId: string): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/candidatenote/candidateNote/{candidateNoteId}";
        if (candidateNoteId === undefined || candidateNoteId === null)
            throw new globalThis.Error("The parameter 'candidateNoteId' must be defined.");
        url_ = url_.replace("{candidateNoteId}", encodeURIComponent("" + candidateNoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCandidateNoteById(_response);
        });
    }

    protected processDeleteCandidateNoteById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get CandidateNote
     * @return Success
     */
    getCandidateNoteById(candidateNoteId: string): Promise<CandidateNoteDetailModel> {
        let url_ = this.baseUrl + "/marketplace/candidatenote/candidateNote/{candidateNoteId}";
        if (candidateNoteId === undefined || candidateNoteId === null)
            throw new globalThis.Error("The parameter 'candidateNoteId' must be defined.");
        url_ = url_.replace("{candidateNoteId}", encodeURIComponent("" + candidateNoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCandidateNoteById(_response);
        });
    }

    protected processGetCandidateNoteById(response: Response): Promise<CandidateNoteDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateNoteDetailModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CandidateNoteDetailModel>(null as any);
    }

    /**
     * Edit CandidateNote
     * @param body (optional) 
     * @return Success
     */
    editCandidateNote(body: EditCandidateNoteRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/candidatenote/candidateNotes/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditCandidateNote(_response);
        });
    }

    protected processEditCandidateNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get Company profile
     * @param companyId Company UUID
     * @return Success
     */
    getCompanyProfile(companyId: string): Promise<CompanyProfilePresentationModel> {
        let url_ = this.baseUrl + "/marketplace/companies/{companyId}/profile";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCompanyProfile(_response);
        });
    }

    protected processGetCompanyProfile(response: Response): Promise<CompanyProfilePresentationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyProfilePresentationModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyProfilePresentationModel>(null as any);
    }

    /**
     * Follow to company
     * @param companyId Company UUID
     * @return No Content
     */
    followToCompany(companyId: string): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/companies/{companyId}/follow";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFollowToCompany(_response);
        });
    }

    protected processFollowToCompany(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Unfollow from company
     * @param companyId Company UUID
     * @return No Content
     */
    unfollowFromCompany(companyId: string): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/companies/{companyId}/unfollow";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnfollowFromCompany(_response);
        });
    }

    protected processUnfollowFromCompany(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get fill data for registration new account
     * @param pageNumber (optional) 
     * @return Success
     */
    getFollowingCompanies(pageNumber: number | undefined): Promise<FollowerCompanyItemViewModelPagedResponseModel> {
        let url_ = this.baseUrl + "/marketplace/companies/following-companies?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFollowingCompanies(_response);
        });
    }

    protected processGetFollowingCompanies(response: Response): Promise<FollowerCompanyItemViewModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FollowerCompanyItemViewModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FollowerCompanyItemViewModelPagedResponseModel>(null as any);
    }

    /**
     * check unique CompanyName
     * @param companyName Checking Company name
     * @return Success
     */
    checkUniqueCompanyName(companyName: string): Promise<CheckUniqueCompanyNameResponse> {
        let url_ = this.baseUrl + "/marketplace/companies/is-unique-company-name?";
        if (companyName === undefined || companyName === null)
            throw new globalThis.Error("The parameter 'companyName' must be defined and cannot be null.");
        else
            url_ += "companyName=" + encodeURIComponent("" + companyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckUniqueCompanyName(_response);
        });
    }

    protected processCheckUniqueCompanyName(response: Response): Promise<CheckUniqueCompanyNameResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CheckUniqueCompanyNameResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckUniqueCompanyNameResponse>(null as any);
    }

    /**
     * Get Company sizes
     * @return Success
     */
    getListCompanySizes(): Promise<CompanySizeModel[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/company-sizes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetListCompanySizes(_response);
        });
    }

    protected processGetListCompanySizes(response: Response): Promise<CompanySizeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanySizeModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanySizeModel[]>(null as any);
    }

    /**
     * Views
     * @param date (optional) 
     * @param chartsDurationType (optional) 
     * @param timeZoneOffset (optional) 
     * @return Success
     */
    getViews(date: Date | undefined, chartsDurationType: DashboardDurationEnum | undefined, timeZoneOffset: number | undefined): Promise<ViewsResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboard/views?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (chartsDurationType === null)
            throw new globalThis.Error("The parameter 'chartsDurationType' cannot be null.");
        else if (chartsDurationType !== undefined)
            url_ += "ChartsDurationType=" + encodeURIComponent("" + chartsDurationType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetViews(_response);
        });
    }

    protected processGetViews(response: Response): Promise<ViewsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ViewsResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewsResponseModel>(null as any);
    }

    /**
     * Submissions
     * @param date (optional) 
     * @param chartsDurationType (optional) 
     * @param timeZoneOffset (optional) 
     * @return Success
     */
    getSubmissions(date: Date | undefined, chartsDurationType: DashboardDurationEnum | undefined, timeZoneOffset: number | undefined): Promise<SubmissionsResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboard/submissions?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (chartsDurationType === null)
            throw new globalThis.Error("The parameter 'chartsDurationType' cannot be null.");
        else if (chartsDurationType !== undefined)
            url_ += "ChartsDurationType=" + encodeURIComponent("" + chartsDurationType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubmissions(_response);
        });
    }

    protected processGetSubmissions(response: Response): Promise<SubmissionsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubmissionsResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmissionsResponseModel>(null as any);
    }

    /**
     * Job views
     * @param pageNumber (optional) 
     * @param date (optional) 
     * @param chartsDurationType (optional) 
     * @param timeZoneOffset (optional) 
     * @return Success
     */
    getJobViews(pageNumber: number | undefined, date: Date | undefined, chartsDurationType: DashboardDurationEnum | undefined, timeZoneOffset: number | undefined): Promise<JobViewsResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboard/job-views?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (chartsDurationType === null)
            throw new globalThis.Error("The parameter 'chartsDurationType' cannot be null.");
        else if (chartsDurationType !== undefined)
            url_ += "ChartsDurationType=" + encodeURIComponent("" + chartsDurationType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobViews(_response);
        });
    }

    protected processGetJobViews(response: Response): Promise<JobViewsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobViewsResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobViewsResponseModel>(null as any);
    }

    /**
     * Job submissions
     * @param pageNumber (optional) 
     * @param date (optional) 
     * @param chartsDurationType (optional) 
     * @param timeZoneOffset (optional) 
     * @return Success
     */
    getJobSubmissions(pageNumber: number | undefined, date: Date | undefined, chartsDurationType: DashboardDurationEnum | undefined, timeZoneOffset: number | undefined): Promise<JobSubmissionsResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboard/job-submissions?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (chartsDurationType === null)
            throw new globalThis.Error("The parameter 'chartsDurationType' cannot be null.");
        else if (chartsDurationType !== undefined)
            url_ += "ChartsDurationType=" + encodeURIComponent("" + chartsDurationType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobSubmissions(_response);
        });
    }

    protected processGetJobSubmissions(response: Response): Promise<JobSubmissionsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobSubmissionsResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobSubmissionsResponseModel>(null as any);
    }

    /**
     * Partners received submissions
     * @param date (optional) 
     * @param chartsDurationType (optional) 
     * @param timeZoneOffset (optional) 
     * @param status (optional) 
     * @return Success
     */
    getPartnersReceivedSubmissions(date: Date | undefined, chartsDurationType: DashboardDurationEnum | undefined, timeZoneOffset: number | undefined, status: CandidateStatusEnum | undefined): Promise<PartnersSubmissionsResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboard/partners/received-submissions?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (chartsDurationType === null)
            throw new globalThis.Error("The parameter 'chartsDurationType' cannot be null.");
        else if (chartsDurationType !== undefined)
            url_ += "ChartsDurationType=" + encodeURIComponent("" + chartsDurationType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPartnersReceivedSubmissions(_response);
        });
    }

    protected processGetPartnersReceivedSubmissions(response: Response): Promise<PartnersSubmissionsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartnersSubmissionsResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartnersSubmissionsResponseModel>(null as any);
    }

    /**
     * Partners submitted submissions
     * @param date (optional) 
     * @param chartsDurationType (optional) 
     * @param timeZoneOffset (optional) 
     * @param status (optional) 
     * @return Success
     */
    getPartnersSubmittedSubmissions(date: Date | undefined, chartsDurationType: DashboardDurationEnum | undefined, timeZoneOffset: number | undefined, status: CandidateStatusEnum | undefined): Promise<PartnersSubmissionsResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboard/partners/submitted-submissions?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (chartsDurationType === null)
            throw new globalThis.Error("The parameter 'chartsDurationType' cannot be null.");
        else if (chartsDurationType !== undefined)
            url_ += "ChartsDurationType=" + encodeURIComponent("" + chartsDurationType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPartnersSubmittedSubmissions(_response);
        });
    }

    protected processGetPartnersSubmittedSubmissions(response: Response): Promise<PartnersSubmissionsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartnersSubmissionsResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartnersSubmissionsResponseModel>(null as any);
    }

    /**
     * Partners submissions
     * @param pageNumber (optional) 
     * @param date (optional) 
     * @param chartsDurationType (optional) 
     * @param timeZoneOffset (optional) 
     * @param status (optional) 
     * @param type (optional) 
     * @return Success
     */
    getPartnersSubmissions(pageNumber: number | undefined, date: Date | undefined, chartsDurationType: DashboardDurationEnum | undefined, timeZoneOffset: number | undefined, status: CandidateStatusEnum | undefined, type: PartnersSubmissionsRequestEnum | undefined): Promise<PagedPartnersSubmissionsResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboard/partners-submissions?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (chartsDurationType === null)
            throw new globalThis.Error("The parameter 'chartsDurationType' cannot be null.");
        else if (chartsDurationType !== undefined)
            url_ += "ChartsDurationType=" + encodeURIComponent("" + chartsDurationType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPartnersSubmissions(_response);
        });
    }

    protected processGetPartnersSubmissions(response: Response): Promise<PagedPartnersSubmissionsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedPartnersSubmissionsResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedPartnersSubmissionsResponseModel>(null as any);
    }

    /**
     * Assigned jobs
     * @param date (optional) 
     * @param chartsDurationType (optional) 
     * @param timeZoneOffset (optional) 
     * @return Success
     */
    getJobsAssignedByPartners(date: Date | undefined, chartsDurationType: DashboardDurationEnum | undefined, timeZoneOffset: number | undefined): Promise<JobAssignedChartResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboard/jobs-assigned?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (chartsDurationType === null)
            throw new globalThis.Error("The parameter 'chartsDurationType' cannot be null.");
        else if (chartsDurationType !== undefined)
            url_ += "ChartsDurationType=" + encodeURIComponent("" + chartsDurationType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobsAssignedByPartners(_response);
        });
    }

    protected processGetJobsAssignedByPartners(response: Response): Promise<JobAssignedChartResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobAssignedChartResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobAssignedChartResponseModel>(null as any);
    }

    /**
     * list of assigned jobs
     * @param pageNumber (optional) 
     * @param date (optional) 
     * @param chartsDurationType (optional) 
     * @param timeZoneOffset (optional) 
     * @return Success
     */
    getJobsAssignedListByPartners(pageNumber: number | undefined, date: Date | undefined, chartsDurationType: DashboardDurationEnum | undefined, timeZoneOffset: number | undefined): Promise<PagedJobAssignedResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboard/jobs-assigned-list?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (chartsDurationType === null)
            throw new globalThis.Error("The parameter 'chartsDurationType' cannot be null.");
        else if (chartsDurationType !== undefined)
            url_ += "ChartsDurationType=" + encodeURIComponent("" + chartsDurationType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobsAssignedListByPartners(_response);
        });
    }

    protected processGetJobsAssignedListByPartners(response: Response): Promise<PagedJobAssignedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedJobAssignedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedJobAssignedResponseModel>(null as any);
    }

    /**
     * Received candidates. Pie chart
     * @param chartDurationType (optional) 
     * @return Success
     */
    getReceivedCandidatesChart(chartDurationType: DashboardDurationEnum | undefined): Promise<CandidatesPieChartResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboard/pie-charts/candidates/received?";
        if (chartDurationType === null)
            throw new globalThis.Error("The parameter 'chartDurationType' cannot be null.");
        else if (chartDurationType !== undefined)
            url_ += "ChartDurationType=" + encodeURIComponent("" + chartDurationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReceivedCandidatesChart(_response);
        });
    }

    protected processGetReceivedCandidatesChart(response: Response): Promise<CandidatesPieChartResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidatesPieChartResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CandidatesPieChartResponseModel>(null as any);
    }

    /**
     * Received candidates. Pie chart. Details
     * @param chartDurationType (optional) 
     * @param candidateStatus (optional) 
     * @return Success
     */
    getReceivedCandidatesDetailChart(chartDurationType: DashboardDurationEnum | undefined, candidateStatus: CandidateStatusEnum | undefined): Promise<CandidateDetailPieChartResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboard/pie-charts/candidates/received/detail?";
        if (chartDurationType === null)
            throw new globalThis.Error("The parameter 'chartDurationType' cannot be null.");
        else if (chartDurationType !== undefined)
            url_ += "ChartDurationType=" + encodeURIComponent("" + chartDurationType) + "&";
        if (candidateStatus === null)
            throw new globalThis.Error("The parameter 'candidateStatus' cannot be null.");
        else if (candidateStatus !== undefined)
            url_ += "CandidateStatus=" + encodeURIComponent("" + candidateStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReceivedCandidatesDetailChart(_response);
        });
    }

    protected processGetReceivedCandidatesDetailChart(response: Response): Promise<CandidateDetailPieChartResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateDetailPieChartResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CandidateDetailPieChartResponseModel>(null as any);
    }

    /**
     * Submitted candidates. Pie chart
     * @param chartDurationType (optional) 
     * @return Success
     */
    getSubmittedCandidatesChart(chartDurationType: DashboardDurationEnum | undefined): Promise<CandidatesPieChartResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboard/pie-charts/candidates/submitted?";
        if (chartDurationType === null)
            throw new globalThis.Error("The parameter 'chartDurationType' cannot be null.");
        else if (chartDurationType !== undefined)
            url_ += "ChartDurationType=" + encodeURIComponent("" + chartDurationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubmittedCandidatesChart(_response);
        });
    }

    protected processGetSubmittedCandidatesChart(response: Response): Promise<CandidatesPieChartResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidatesPieChartResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CandidatesPieChartResponseModel>(null as any);
    }

    /**
     * Submitted candidates. Pie chart. Details
     * @param chartDurationType (optional) 
     * @param candidateStatus (optional) 
     * @return Success
     */
    getSubmittedCandidatesDetailChart(chartDurationType: DashboardDurationEnum | undefined, candidateStatus: CandidateStatusEnum | undefined): Promise<CandidateDetailPieChartResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboard/pie-charts/candidates/submitted/detail?";
        if (chartDurationType === null)
            throw new globalThis.Error("The parameter 'chartDurationType' cannot be null.");
        else if (chartDurationType !== undefined)
            url_ += "ChartDurationType=" + encodeURIComponent("" + chartDurationType) + "&";
        if (candidateStatus === null)
            throw new globalThis.Error("The parameter 'candidateStatus' cannot be null.");
        else if (candidateStatus !== undefined)
            url_ += "CandidateStatus=" + encodeURIComponent("" + candidateStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubmittedCandidatesDetailChart(_response);
        });
    }

    protected processGetSubmittedCandidatesDetailChart(response: Response): Promise<CandidateDetailPieChartResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateDetailPieChartResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CandidateDetailPieChartResponseModel>(null as any);
    }

    /**
     * Get total numbers
     * @return Success
     */
    getTotalNumbers(): Promise<TotalNumbersModel> {
        let url_ = this.baseUrl + "/marketplace/dashboard/total-numbers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTotalNumbers(_response);
        });
    }

    protected processGetTotalNumbers(response: Response): Promise<TotalNumbersModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TotalNumbersModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TotalNumbersModel>(null as any);
    }

    /**
     * Get list of companies by candidates received
     * @param pageNumber (optional) 
     * @param date (optional) 
     * @param chartsDurationType (optional) 
     * @param timeZoneOffset (optional) 
     * @return Success
     */
    getCompaniesCandidatesList(pageNumber: number | undefined, date: Date | undefined, chartsDurationType: DashboardDurationEnum | undefined, timeZoneOffset: number | undefined): Promise<PagedCompanyCandidateResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboards/home/candidates/received/company-list?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (chartsDurationType === null)
            throw new globalThis.Error("The parameter 'chartsDurationType' cannot be null.");
        else if (chartsDurationType !== undefined)
            url_ += "ChartsDurationType=" + encodeURIComponent("" + chartsDurationType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCompaniesCandidatesList(_response);
        });
    }

    protected processGetCompaniesCandidatesList(response: Response): Promise<PagedCompanyCandidateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedCompanyCandidateResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedCompanyCandidateResponseModel>(null as any);
    }

    /**
     * Get list of requests by submitted candidates
     * @param pageNumber (optional) 
     * @param date (optional) 
     * @param chartsDurationType (optional) 
     * @param timeZoneOffset (optional) 
     * @return Success
     */
    getRequestsCandidatesList(pageNumber: number | undefined, date: Date | undefined, chartsDurationType: DashboardDurationEnum | undefined, timeZoneOffset: number | undefined): Promise<PagedCompanyRequestResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboards/home/candidates/requests-list?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (chartsDurationType === null)
            throw new globalThis.Error("The parameter 'chartsDurationType' cannot be null.");
        else if (chartsDurationType !== undefined)
            url_ += "ChartsDurationType=" + encodeURIComponent("" + chartsDurationType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRequestsCandidatesList(_response);
        });
    }

    protected processGetRequestsCandidatesList(response: Response): Promise<PagedCompanyRequestResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedCompanyRequestResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedCompanyRequestResponseModel>(null as any);
    }

    /**
     * Get job posted
     * @param pageNumber (optional) 
     * @param date (optional) 
     * @param chartsDurationType (optional) 
     * @param timeZoneOffset (optional) 
     * @return Success
     */
    getJobPostingCreatedList(pageNumber: number | undefined, date: Date | undefined, chartsDurationType: DashboardDurationEnum | undefined, timeZoneOffset: number | undefined): Promise<PagedJobPostingsCreatedResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboards/home/jobs/posted-list?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (chartsDurationType === null)
            throw new globalThis.Error("The parameter 'chartsDurationType' cannot be null.");
        else if (chartsDurationType !== undefined)
            url_ += "ChartsDurationType=" + encodeURIComponent("" + chartsDurationType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobPostingCreatedList(_response);
        });
    }

    protected processGetJobPostingCreatedList(response: Response): Promise<PagedJobPostingsCreatedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedJobPostingsCreatedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedJobPostingsCreatedResponseModel>(null as any);
    }

    /**
     * Get partnership requests
     * @param pageNumber (optional) 
     * @param date (optional) 
     * @param chartsDurationType (optional) 
     * @param timeZoneOffset (optional) 
     * @return Success
     */
    getPartnerRequests(pageNumber: number | undefined, date: Date | undefined, chartsDurationType: DashboardDurationEnum | undefined, timeZoneOffset: number | undefined): Promise<PagedPartnershipRequestsResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboards/home/partners/requests-list?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (chartsDurationType === null)
            throw new globalThis.Error("The parameter 'chartsDurationType' cannot be null.");
        else if (chartsDurationType !== undefined)
            url_ += "ChartsDurationType=" + encodeURIComponent("" + chartsDurationType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPartnerRequests(_response);
        });
    }

    protected processGetPartnerRequests(response: Response): Promise<PagedPartnershipRequestsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedPartnershipRequestsResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedPartnershipRequestsResponseModel>(null as any);
    }

    /**
     * list of assigned jobs
     * @param pageNumber (optional) 
     * @param date (optional) 
     * @param chartsDurationType (optional) 
     * @param timeZoneOffset (optional) 
     * @return Success
     */
    getHomeJobsAssignedListByPartners(pageNumber: number | undefined, date: Date | undefined, chartsDurationType: DashboardDurationEnum | undefined, timeZoneOffset: number | undefined): Promise<PagedJobAssignedResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboards/home/jobs/assigned-list?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (chartsDurationType === null)
            throw new globalThis.Error("The parameter 'chartsDurationType' cannot be null.");
        else if (chartsDurationType !== undefined)
            url_ += "ChartsDurationType=" + encodeURIComponent("" + chartsDurationType) + "&";
        if (timeZoneOffset === null)
            throw new globalThis.Error("The parameter 'timeZoneOffset' cannot be null.");
        else if (timeZoneOffset !== undefined)
            url_ += "TimeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHomeJobsAssignedListByPartners(_response);
        });
    }

    protected processGetHomeJobsAssignedListByPartners(response: Response): Promise<PagedJobAssignedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedJobAssignedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedJobAssignedResponseModel>(null as any);
    }

    /**
     * Get Recommended Candidates
     * @return Success
     */
    getRecommendedCandidates(): Promise<RecommendedCandidatesResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboards/home/candidates/recommended";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRecommendedCandidates(_response);
        });
    }

    protected processGetRecommendedCandidates(response: Response): Promise<RecommendedCandidatesResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RecommendedCandidatesResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecommendedCandidatesResponseModel>(null as any);
    }

    /**
     * Jobs dashboard. My active jobs.
     * @return Success
     */
    getMyActiveJobsChart(): Promise<JobsPieChartResponseModel> {
        let url_ = this.baseUrl + "/marketplace/jobs/dashboard/pie-charts/active";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyActiveJobsChart(_response);
        });
    }

    protected processGetMyActiveJobsChart(response: Response): Promise<JobsPieChartResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobsPieChartResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobsPieChartResponseModel>(null as any);
    }

    /**
     * Jobs dashboard. My active jobs. Details.
     * @return Success
     */
    getMyActiveJobsChartDetails(pageNumber: number): Promise<JobPieChartDetailsResponseModel> {
        let url_ = this.baseUrl + "/marketplace/jobs/dashboard/pie-charts/active/details?";
        if (pageNumber === undefined || pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyActiveJobsChartDetails(_response);
        });
    }

    protected processGetMyActiveJobsChartDetails(response: Response): Promise<JobPieChartDetailsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobPieChartDetailsResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobPieChartDetailsResponseModel>(null as any);
    }

    /**
     * Get my job submissions
     * @param pageSize (optional) 
     * @return Success
     */
    getMyJobSubmissions(pageSize: number | undefined): Promise<JobCandidatesSummaryModelTopListResponseModel> {
        let url_ = this.baseUrl + "/marketplace/jobs/dashboard/submissions?";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyJobSubmissions(_response);
        });
    }

    protected processGetMyJobSubmissions(response: Response): Promise<JobCandidatesSummaryModelTopListResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobCandidatesSummaryModelTopListResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobCandidatesSummaryModelTopListResponseModel>(null as any);
    }

    /**
     * Get my recent jobs
     * @param pageSize (optional) 
     * @return Success
     */
    getMyRecentJobs(pageSize: number | undefined): Promise<JobCandidatesSummaryModel[]> {
        let url_ = this.baseUrl + "/marketplace/jobs/dashboard/recent?";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyRecentJobs(_response);
        });
    }

    protected processGetMyRecentJobs(response: Response): Promise<JobCandidatesSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobCandidatesSummaryModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobCandidatesSummaryModel[]>(null as any);
    }

    /**
     * Get jobs expiring soon
     * @param pageSize (optional) 
     * @return Success
     */
    getJobsExpiringSoon(pageSize: number | undefined): Promise<JobCandidatesSummaryModel[]> {
        let url_ = this.baseUrl + "/marketplace/jobs/dashboard/expiring-soon?";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobsExpiringSoon(_response);
        });
    }

    protected processGetJobsExpiringSoon(response: Response): Promise<JobCandidatesSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobCandidatesSummaryModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobCandidatesSummaryModel[]>(null as any);
    }

    /**
     * Create Department
     * @param body (optional) 
     * @return Success
     */
    createDepartment(body: CreateDepartmentModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/department/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateDepartment(_response);
        });
    }

    protected processCreateDepartment(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Edit Department
     * @param body (optional) 
     * @return Success
     */
    editDepartment(body: UpdateDepartmentModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/department/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditDepartment(_response);
        });
    }

    protected processEditDepartment(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get Department Details
     * @param departmentId (optional) 
     * @return Success
     */
    getDepartmentDetails(departmentId: string | undefined): Promise<DepartmentEntity> {
        let url_ = this.baseUrl + "/marketplace/department/details?";
        if (departmentId === null)
            throw new globalThis.Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDepartmentDetails(_response);
        });
    }

    protected processGetDepartmentDetails(response: Response): Promise<DepartmentEntity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DepartmentEntity;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepartmentEntity>(null as any);
    }

    /**
     * Get my Departments
     * @param pageNumber (optional) 
     * @return Success
     */
    getMyDepartments(pageNumber: number | undefined): Promise<DepartmentViewModelPagedResponseModel> {
        let url_ = this.baseUrl + "/marketplace/department/my-departments?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyDepartments(_response);
        });
    }

    protected processGetMyDepartments(response: Response): Promise<DepartmentViewModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DepartmentViewModelPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepartmentViewModelPagedResponseModel>(null as any);
    }

    /**
     * Get my Departments For Dropdown
     * @return Success
     */
    getMyDepartmentsForDropdown(): Promise<DepartmentSimpleViewModel[]> {
        let url_ = this.baseUrl + "/marketplace/department/my-departments/dropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyDepartmentsForDropdown(_response);
        });
    }

    protected processGetMyDepartmentsForDropdown(response: Response): Promise<DepartmentSimpleViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DepartmentSimpleViewModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepartmentSimpleViewModel[]>(null as any);
    }

    /**
     * Get educations
     * @return Success
     */
    getListEducations(): Promise<EducationEntity[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/educations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetListEducations(_response);
        });
    }

    protected processGetListEducations(response: Response): Promise<EducationEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducationEntity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EducationEntity[]>(null as any);
    }

    /**
     * Get yearsExperiences
     * @return Success
     */
    getListYearsExperiences(): Promise<YearsExperienceEntity[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/yearsExperiences";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetListYearsExperiences(_response);
        });
    }

    protected processGetListYearsExperiences(response: Response): Promise<YearsExperienceEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as YearsExperienceEntity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<YearsExperienceEntity[]>(null as any);
    }

    /**
     * Get acceptablePermissions
     * @return Success
     */
    getListAcceptablePermissions(): Promise<AcceptablePermissionEntity[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/acceptablePermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetListAcceptablePermissions(_response);
        });
    }

    protected processGetListAcceptablePermissions(response: Response): Promise<AcceptablePermissionEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AcceptablePermissionEntity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AcceptablePermissionEntity[]>(null as any);
    }

    /**
     * Get certifications
     * @return Success
     */
    getListCertifications(): Promise<CertificationEntity[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/certifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetListCertifications(_response);
        });
    }

    protected processGetListCertifications(response: Response): Promise<CertificationEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CertificationEntity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CertificationEntity[]>(null as any);
    }

    /**
     * Get benefits
     * @return Success
     */
    getListBenefits(): Promise<BenefitEntity[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/benefits";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetListBenefits(_response);
        });
    }

    protected processGetListBenefits(response: Response): Promise<BenefitEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BenefitEntity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BenefitEntity[]>(null as any);
    }

    /**
     * Get withdrawal reasons
     * @return Success
     */
    getAllWithdrawReasons(): Promise<CandidateReasonEntity[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/withdraw-reasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllWithdrawReasons(_response);
        });
    }

    protected processGetAllWithdrawReasons(response: Response): Promise<CandidateReasonEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateReasonEntity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CandidateReasonEntity[]>(null as any);
    }

    /**
     * Get decline reasons
     * @return Success
     */
    getAllDeclineReasons(): Promise<CandidateReasonEntity[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/decline-reasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllDeclineReasons(_response);
        });
    }

    protected processGetAllDeclineReasons(response: Response): Promise<CandidateReasonEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateReasonEntity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CandidateReasonEntity[]>(null as any);
    }

    /**
     * Get companies
     * @return Success
     */
    getAllCompanies(): Promise<CompanyDictionaryModel[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllCompanies(_response);
        });
    }

    protected processGetAllCompanies(response: Response): Promise<CompanyDictionaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyDictionaryModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyDictionaryModel[]>(null as any);
    }

    /**
     * Get specializations
     * @return Success
     */
    getListSpecializations(): Promise<SkillEntity[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/specializations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetListSpecializations(_response);
        });
    }

    protected processGetListSpecializations(response: Response): Promise<SkillEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SkillEntity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SkillEntity[]>(null as any);
    }

    /**
     * Get qualifications
     * @return Success
     */
    getListQualifications(): Promise<QualificationEntity[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/qualifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetListQualifications(_response);
        });
    }

    protected processGetListQualifications(response: Response): Promise<QualificationEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QualificationEntity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QualificationEntity[]>(null as any);
    }

    /**
     * Get jobExpirations
     * @return Success
     */
    getListJobExpirations(): Promise<JobExpirationEntity[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/jobexpirations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetListJobExpirations(_response);
        });
    }

    protected processGetListJobExpirations(response: Response): Promise<JobExpirationEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobExpirationEntity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobExpirationEntity[]>(null as any);
    }

    /**
     * Get unpublish reasons
     * @return Success
     */
    getAllUnpublishReasons(): Promise<UnpublishJobReasonTypeEntity[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/job/unpublish-reason";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllUnpublishReasons(_response);
        });
    }

    protected processGetAllUnpublishReasons(response: Response): Promise<UnpublishJobReasonTypeEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnpublishJobReasonTypeEntity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnpublishJobReasonTypeEntity[]>(null as any);
    }

    /**
     * Get countries
     * @return Success
     */
    getListCountries(): Promise<CountryEntity[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetListCountries(_response);
        });
    }

    protected processGetListCountries(response: Response): Promise<CountryEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountryEntity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryEntity[]>(null as any);
    }

    /**
     * Get international cities
     * @return Success
     */
    getListInternationalCities(): Promise<InternationalCityEntity[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/international-cities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetListInternationalCities(_response);
        });
    }

    protected processGetListInternationalCities(response: Response): Promise<InternationalCityEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InternationalCityEntity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InternationalCityEntity[]>(null as any);
    }

    /**
     * Get all mp short members
     * @return Success
     */
    getListMPMembers(): Promise<MPMemberShortViewModel[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/all/MPMebmers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetListMPMembers(_response);
        });
    }

    protected processGetListMPMembers(response: Response): Promise<MPMemberShortViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MPMemberShortViewModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MPMemberShortViewModel[]>(null as any);
    }

    /**
     * Get all posts for user
     * @param pageNumber (optional) 
     * @return Success
     */
    getPostsForUser(pageNumber: number | undefined): Promise<PostResponseModel> {
        let url_ = this.baseUrl + "/marketplace/feed/posts?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPostsForUser(_response);
        });
    }

    protected processGetPostsForUser(response: Response): Promise<PostResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PostResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PostResponseModel>(null as any);
    }

    /**
     * Create new post to feed
     * @param body (optional) 
     * @return Success
     */
    createNewPost(body: CreateNewPostRequest | undefined): Promise<PostDetailModel> {
        let url_ = this.baseUrl + "/marketplace/feed/posts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewPost(_response);
        });
    }

    protected processCreateNewPost(response: Response): Promise<PostDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PostDetailModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PostDetailModel>(null as any);
    }

    /**
     * Delete post
     * @return Success
     */
    deletePostById(postId: string): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/feed/posts/{postId}";
        if (postId === undefined || postId === null)
            throw new globalThis.Error("The parameter 'postId' must be defined.");
        url_ = url_.replace("{postId}", encodeURIComponent("" + postId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePostById(_response);
        });
    }

    protected processDeletePostById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get link and key for upload image
     * @param image_ext (optional) Extension for file, one of [jpg, jpeg, png]
     * @return Success
     */
    getPostsImageUploadLink(image_ext: string | undefined): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/marketplace/feed/upload/image-link?";
        if (image_ext === null)
            throw new globalThis.Error("The parameter 'image_ext' cannot be null.");
        else if (image_ext !== undefined)
            url_ += "image-ext=" + encodeURIComponent("" + image_ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPostsImageUploadLink(_response);
        });
    }

    protected processGetPostsImageUploadLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Get industries
     * @return Success
     */
    getListIndustries(): Promise<IndustryEntity[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/industries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetListIndustries(_response);
        });
    }

    protected processGetListIndustries(response: Response): Promise<IndustryEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IndustryEntity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IndustryEntity[]>(null as any);
    }

    /**
     * Create Job
     * @param body (optional) 
     * @return Success
     */
    createJob(body: JobModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/jobs/createjob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateJob(_response);
        });
    }

    protected processCreateJob(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Create Draft Job
     * @param body (optional) 
     * @return Success
     */
    createDraftJob(body: JobDraftModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/jobs/createdraftjob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateDraftJob(_response);
        });
    }

    protected processCreateDraftJob(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Edit Job
     * @param body (optional) 
     * @return Success
     */
    editJob(body: JobModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/jobs/editjob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditJob(_response);
        });
    }

    protected processEditJob(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Edit Draft Job
     * @param body (optional) 
     * @return Success
     */
    editDraftJob(body: JobDraftModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/jobs/editdraftjob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditDraftJob(_response);
        });
    }

    protected processEditDraftJob(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get job titles
     * @return Success
     */
    getJobTitles(): Promise<JobTitleEntity[]> {
        let url_ = this.baseUrl + "/marketplace/jobs/getjobtitles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobTitles(_response);
        });
    }

    protected processGetJobTitles(response: Response): Promise<JobTitleEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobTitleEntity[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobTitleEntity[]>(null as any);
    }

    /**
     * Get job details
     * @param id (optional) 
     * @return Success
     */
    getJobDetails(id: string | undefined): Promise<JobDetailResponseModel> {
        let url_ = this.baseUrl + "/marketplace/jobs/getjobdetails?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobDetails(_response);
        });
    }

    protected processGetJobDetails(response: Response): Promise<JobDetailResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobDetailResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobDetailResponseModel>(null as any);
    }

    /**
     * Get last job titles for company
     * @param companyId Target company id to get posted jobs
     * @return Success
     */
    getLastJobTitlesForCompany(companyId: string): Promise<EntityListItemViewModel[]> {
        let url_ = this.baseUrl + "/marketplace/jobs/company/{companyId}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLastJobTitlesForCompany(_response);
        });
    }

    protected processGetLastJobTitlesForCompany(response: Response): Promise<EntityListItemViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityListItemViewModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityListItemViewModel[]>(null as any);
    }

    /**
     * Add job view
     * @param id (optional) 
     * @return Success
     */
    addJobView(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/jobs/addjobview?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddJobView(_response);
        });
    }

    protected processAddJobView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete job
     * @param jobId Job UUID
     * @return Success
     */
    deleteJob(jobId: string): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/jobs/{jobId}/delete";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteJob(_response);
        });
    }

    protected processDeleteJob(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update JobDate
     * @param jobId Job UUID
     * @return Success
     */
    updateJobDate(jobId: string): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/jobs/{jobId}/update-date";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateJobDate(_response);
        });
    }

    protected processUpdateJobDate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Publish job
     * @param id (optional) 
     * @return Success
     */
    publishJob(id: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/jobs/publishjob?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublishJob(_response);
        });
    }

    protected processPublishJob(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Unpublish job
     * @param body (optional) 
     * @return Success
     */
    unpublishJob(body: UnpublishJobRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/jobs/unpublishjob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnpublishJob(_response);
        });
    }

    protected processUnpublishJob(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * has-pending-candidates
     * @param id (optional) 
     * @return Success
     */
    hasPendingCandidate(id: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/marketplace/jobs/has-pending-candidates?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasPendingCandidate(_response);
        });
    }

    protected processHasPendingCandidate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * has-candidates
     * @param id (optional) 
     * @return Success
     */
    hasCandidates(id: string | undefined): Promise<JobHasCandidatesResponseModel> {
        let url_ = this.baseUrl + "/marketplace/jobs/has-candidates?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHasCandidates(_response);
        });
    }

    protected processHasCandidates(response: Response): Promise<JobHasCandidatesResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobHasCandidatesResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobHasCandidatesResponseModel>(null as any);
    }

    /**
     * Corporate jobs
     * @param pageNumber PageNumber
     * @return Success
     */
    getCorporateJobsPaged(pageNumber: number): Promise<JobDetailListModel> {
        let url_ = this.baseUrl + "/marketplace/jobs/corporate?";
        if (pageNumber === undefined || pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCorporateJobsPaged(_response);
        });
    }

    protected processGetCorporateJobsPaged(response: Response): Promise<JobDetailListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobDetailListModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobDetailListModel>(null as any);
    }

    /**
     * Get candidate details
     * @param jobCandidateId (optional) 
     * @return Success
     */
    getJobCandidateByIdDetails(jobCandidateId: string | undefined): Promise<JobCandidateResponse> {
        let url_ = this.baseUrl + "/marketplace/job-candidate/job-candidate?";
        if (jobCandidateId === null)
            throw new globalThis.Error("The parameter 'jobCandidateId' cannot be null.");
        else if (jobCandidateId !== undefined)
            url_ += "jobCandidateId=" + encodeURIComponent("" + jobCandidateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobCandidateByIdDetails(_response);
        });
    }

    protected processGetJobCandidateByIdDetails(response: Response): Promise<JobCandidateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobCandidateResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobCandidateResponse>(null as any);
    }

    /**
     * Mark job candidate indicator for stage viewed
     * @return No Content
     */
    markJobCandidateIndicatorViewed(jobCandidateId: string, stage: CandidateStatusEnum): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/job-candidate/{jobCandidateId}/mark-indicator-viewed?";
        if (jobCandidateId === undefined || jobCandidateId === null)
            throw new globalThis.Error("The parameter 'jobCandidateId' must be defined.");
        url_ = url_.replace("{jobCandidateId}", encodeURIComponent("" + jobCandidateId));
        if (stage === undefined || stage === null)
            throw new globalThis.Error("The parameter 'stage' must be defined and cannot be null.");
        else
            url_ += "stage=" + encodeURIComponent("" + stage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkJobCandidateIndicatorViewed(_response);
        });
    }

    protected processMarkJobCandidateIndicatorViewed(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * get JobCandidate UnViewed Count
     * @param isMember (optional) 
     * @return Success
     */
    getJobCandidateUnViewedCount(isMember: boolean | undefined): Promise<number> {
        let url_ = this.baseUrl + "/marketplace/job-candidate/job-candidate-unviewed-count?";
        if (isMember === null)
            throw new globalThis.Error("The parameter 'isMember' cannot be null.");
        else if (isMember !== undefined)
            url_ += "isMember=" + encodeURIComponent("" + isMember) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobCandidateUnViewedCount(_response);
        });
    }

    protected processGetJobCandidateUnViewedCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Mark As Removed
     * @param body (optional) 
     * @return Success
     */
    markAsRemoved(body: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/jobcandidatematch/markAsRemoved";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkAsRemoved(_response);
        });
    }

    protected processMarkAsRemoved(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Mark As Removed
     * @param jobId (optional) 
     * @return Success
     */
    markAsRemovedAllMatches(jobId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/jobcandidatematch/markAsRemoved-allmatches?";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkAsRemovedAllMatches(_response);
        });
    }

    protected processMarkAsRemovedAllMatches(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Mark As Saved
     * @param body (optional) 
     * @return Success
     */
    markAsSaved(body: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/jobcandidatematch/markAsSaved";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkAsSaved(_response);
        });
    }

    protected processMarkAsSaved(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Mark As UnSaved
     * @param body (optional) 
     * @return Success
     */
    markAsUnSaved(body: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/jobcandidatematch/markAsUnSaved";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkAsUnSaved(_response);
        });
    }

    protected processMarkAsUnSaved(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Mark As Saved All
     * @param jobId (optional) 
     * @return Success
     */
    markAsSavedAll(jobId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/jobcandidatematch/markAsSavedAll?";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkAsSavedAll(_response);
        });
    }

    protected processMarkAsSavedAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Mark As UnSaved All
     * @param jobId (optional) 
     * @return Success
     */
    markAsUnSavedAll(jobId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/jobcandidatematch/markAsUnSavedAll?";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkAsUnSavedAll(_response);
        });
    }

    protected processMarkAsUnSavedAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get JobCandidate Matches
     * @param pageNumber (optional) 
     * @param jobId (optional) 
     * @param isSaved (optional) 
     * @return Success
     */
    getJobCandidateMatches(pageNumber: number | undefined, jobId: string | undefined, isSaved: boolean | undefined): Promise<JobCandidateMatchesModel> {
        let url_ = this.baseUrl + "/marketplace/jobcandidatematch/jcmatches?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (jobId === null)
            throw new globalThis.Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "JobId=" + encodeURIComponent("" + jobId) + "&";
        if (isSaved === null)
            throw new globalThis.Error("The parameter 'isSaved' cannot be null.");
        else if (isSaved !== undefined)
            url_ += "IsSaved=" + encodeURIComponent("" + isSaved) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobCandidateMatches(_response);
        });
    }

    protected processGetJobCandidateMatches(response: Response): Promise<JobCandidateMatchesModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobCandidateMatchesModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobCandidateMatchesModel>(null as any);
    }

    /**
     * Get all jobNotes for company
     * @param pageNumber (optional) 
     * @return Success
     */
    getJobNotesForCompany(jobId: string, pageNumber: number | undefined): Promise<JobNoteDetailModelPagedResponseModel> {
        let url_ = this.baseUrl + "/marketplace/jobnote/jobNotes?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined and cannot be null.");
        else
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobNotesForCompany(_response);
        });
    }

    protected processGetJobNotesForCompany(response: Response): Promise<JobNoteDetailModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobNoteDetailModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobNoteDetailModelPagedResponseModel>(null as any);
    }

    /**
     * Create new jobNote
     * @param body (optional) 
     * @return Success
     */
    createNewJobNote(body: CreateNewJobNoteRequest | undefined): Promise<JobNoteDetailModel> {
        let url_ = this.baseUrl + "/marketplace/jobnote/jobNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewJobNote(_response);
        });
    }

    protected processCreateNewJobNote(response: Response): Promise<JobNoteDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobNoteDetailModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobNoteDetailModel>(null as any);
    }

    /**
     * Delete jobNote
     * @return Success
     */
    deleteJobNoteById(jobNoteId: string): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/jobnote/jobNote/{jobNoteId}";
        if (jobNoteId === undefined || jobNoteId === null)
            throw new globalThis.Error("The parameter 'jobNoteId' must be defined.");
        url_ = url_.replace("{jobNoteId}", encodeURIComponent("" + jobNoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteJobNoteById(_response);
        });
    }

    protected processDeleteJobNoteById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get JobNote
     * @return Success
     */
    getJobNoteById(jobNoteId: string): Promise<JobNoteDetailModel> {
        let url_ = this.baseUrl + "/marketplace/jobnote/jobNote/{jobNoteId}";
        if (jobNoteId === undefined || jobNoteId === null)
            throw new globalThis.Error("The parameter 'jobNoteId' must be defined.");
        url_ = url_.replace("{jobNoteId}", encodeURIComponent("" + jobNoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobNoteById(_response);
        });
    }

    protected processGetJobNoteById(response: Response): Promise<JobNoteDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobNoteDetailModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobNoteDetailModel>(null as any);
    }

    /**
     * Edit JobNote
     * @param body (optional) 
     * @return Success
     */
    editJobNote(body: EditJobNoteRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/jobnote/jobNotes/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditJobNote(_response);
        });
    }

    protected processEditJobNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Edit Job Template
     * @param body (optional) 
     * @return Success
     */
    editJobTemplate(body: JobModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/jobtemplates/jobtemplate/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditJobTemplate(_response);
        });
    }

    protected processEditJobTemplate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get jobtemplate names
     * @return Success
     */
    getJobTemplateNames(): Promise<JobTemplateMiniViewModel[]> {
        let url_ = this.baseUrl + "/marketplace/jobtemplates/get-jobtemplate-names";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobTemplateNames(_response);
        });
    }

    protected processGetJobTemplateNames(response: Response): Promise<JobTemplateMiniViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobTemplateMiniViewModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobTemplateMiniViewModel[]>(null as any);
    }

    /**
     * Get jobtemplate details
     * @param id (optional) 
     * @return Success
     */
    getJobTemplateDetails(id: string | undefined): Promise<JobDetailResponseModel> {
        let url_ = this.baseUrl + "/marketplace/jobtemplates/get-jobtemplate-details?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJobTemplateDetails(_response);
        });
    }

    protected processGetJobTemplateDetails(response: Response): Promise<JobDetailResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobDetailResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobDetailResponseModel>(null as any);
    }

    /**
     * Get my jobtemplates
     * @param pageNumber (optional) 
     * @return Success
     */
    getMyJobTemplates(pageNumber: number | undefined): Promise<JobDetailListModel> {
        let url_ = this.baseUrl + "/marketplace/jobtemplates/get-my-jobtemplates?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyJobTemplates(_response);
        });
    }

    protected processGetMyJobTemplates(response: Response): Promise<JobDetailListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobDetailListModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobDetailListModel>(null as any);
    }

    /**
     * Delete job template
     * @param jobTemplateId Job Template UUID
     * @return Success
     */
    deleteJobTemplate(jobTemplateId: string): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/jobtemplates/{jobTemplateId}/delete";
        if (jobTemplateId === undefined || jobTemplateId === null)
            throw new globalThis.Error("The parameter 'jobTemplateId' must be defined.");
        url_ = url_.replace("{jobTemplateId}", encodeURIComponent("" + jobTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteJobTemplate(_response);
        });
    }

    protected processDeleteJobTemplate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * get jobtitle templates
     * @return Success
     */
    getjobtitletemplates(): Promise<JobTitlesTemplatesModel[]> {
        let url_ = this.baseUrl + "/marketplace/jobtemplates/jobtitle-templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetjobtitletemplates(_response);
        });
    }

    protected processGetjobtitletemplates(response: Response): Promise<JobTitlesTemplatesModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobTitlesTemplatesModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobTitlesTemplatesModel[]>(null as any);
    }

    /**
     * Partners dashboard. My partners.
     * @param pageSize (optional) 
     * @return Success
     */
    getMyPartnersChart(pageSize: number | undefined): Promise<MyPartnersChartResponseModel> {
        let url_ = this.baseUrl + "/marketplace/partners/dashboard/pie-charts/my-partners?";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyPartnersChart(_response);
        });
    }

    protected processGetMyPartnersChart(response: Response): Promise<MyPartnersChartResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MyPartnersChartResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MyPartnersChartResponseModel>(null as any);
    }

    /**
     * Partners dashboard. My partners. Table
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getMyPartnersChartDetails(pageSize: number | undefined, pageNumber: number | undefined): Promise<MyPartnersChartDetailsResponseModel> {
        let url_ = this.baseUrl + "/marketplace/partners/dashboard/pie-charts/my-partners/details?";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyPartnersChartDetails(_response);
        });
    }

    protected processGetMyPartnersChartDetails(response: Response): Promise<MyPartnersChartDetailsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MyPartnersChartDetailsResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MyPartnersChartDetailsResponseModel>(null as any);
    }

    /**
     * Get states
     * @return Success
     */
    getListStates(): Promise<StateEntity[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/states";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetListStates(_response);
        });
    }

    protected processGetListStates(response: Response): Promise<StateEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StateEntity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StateEntity[]>(null as any);
    }

    /**
     * Get cities
     * @return Success
     */
    getListCities(): Promise<CityEntity[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/cities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetListCities(_response);
        });
    }

    protected processGetListCities(response: Response): Promise<CityEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CityEntity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityEntity[]>(null as any);
    }

    /**
     * Search jobs suggestions
     * @param query Search term
     * @param publishStatus (optional) 
     * @return Success
     */
    searchSuggestionsJobTitles(query: string, publishStatus: JobPublishStatus | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/marketplace/search/jobs/suggestions?";
        if (query === undefined || query === null)
            throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (publishStatus === null)
            throw new globalThis.Error("The parameter 'publishStatus' cannot be null.");
        else if (publishStatus !== undefined)
            url_ += "publishStatus=" + encodeURIComponent("" + publishStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchSuggestionsJobTitles(_response);
        });
    }

    protected processSearchSuggestionsJobTitles(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Search jobs
     * @param query (optional) 
     * @param pageNumber (optional) 
     * @param industryIds (optional) 
     * @param cityIds (optional) 
     * @param skillIds (optional) 
     * @param companyIds (optional) 
     * @param sortField (optional) 
     * @param sortType (optional) 
     * @return Success
     */
    searchJobsByTerm(query: string | undefined, pageNumber: number | undefined, industryIds: number[] | undefined, cityIds: number[] | undefined, skillIds: number[] | undefined, companyIds: string[] | undefined, sortField: JobSortFieldEnum | undefined, sortType: SortingEnum | undefined): Promise<JobDetailListModel> {
        let url_ = this.baseUrl + "/marketplace/search/jobs?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (industryIds === null)
            throw new globalThis.Error("The parameter 'industryIds' cannot be null.");
        else if (industryIds !== undefined)
            industryIds && industryIds.forEach(item => { url_ += "IndustryIds=" + encodeURIComponent("" + item) + "&"; });
        if (cityIds === null)
            throw new globalThis.Error("The parameter 'cityIds' cannot be null.");
        else if (cityIds !== undefined)
            cityIds && cityIds.forEach(item => { url_ += "CityIds=" + encodeURIComponent("" + item) + "&"; });
        if (skillIds === null)
            throw new globalThis.Error("The parameter 'skillIds' cannot be null.");
        else if (skillIds !== undefined)
            skillIds && skillIds.forEach(item => { url_ += "SkillIds=" + encodeURIComponent("" + item) + "&"; });
        if (companyIds === null)
            throw new globalThis.Error("The parameter 'companyIds' cannot be null.");
        else if (companyIds !== undefined)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        if (sortField === null)
            throw new globalThis.Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortType === null)
            throw new globalThis.Error("The parameter 'sortType' cannot be null.");
        else if (sortType !== undefined)
            url_ += "SortType=" + encodeURIComponent("" + sortType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchJobsByTerm(_response);
        });
    }

    protected processSearchJobsByTerm(response: Response): Promise<JobDetailListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobDetailListModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobDetailListModel>(null as any);
    }

    /**
     * Search Company suggestions
     * @param query Search term
     * @return Success
     */
    searchSuggestionsCompanyTitles(query: string): Promise<CompanySuggestionProfileModel[]> {
        let url_ = this.baseUrl + "/marketplace/search/companies/suggestions?";
        if (query === undefined || query === null)
            throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchSuggestionsCompanyTitles(_response);
        });
    }

    protected processSearchSuggestionsCompanyTitles(response: Response): Promise<CompanySuggestionProfileModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanySuggestionProfileModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanySuggestionProfileModel[]>(null as any);
    }

    /**
     * Search companies
     * @param query (optional) 
     * @param pageNumber (optional) 
     * @param industryIds (optional) 
     * @param cityIds (optional) 
     * @param skillIds (optional) 
     * @param companyIds (optional) 
     * @param desiredJobs (optional) 
     * @param mostJobPosts (optional) 
     * @param memberIds (optional) 
     * @return Success
     */
    searchCompaniesByTerm(query: string | undefined, pageNumber: number | undefined, industryIds: number[] | undefined, cityIds: number[] | undefined, skillIds: number[] | undefined, companyIds: string[] | undefined, desiredJobs: string[] | undefined, mostJobPosts: SortingEnum | undefined, memberIds: string[] | undefined): Promise<CompanyDetailsListModel> {
        let url_ = this.baseUrl + "/marketplace/search/companies?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (industryIds === null)
            throw new globalThis.Error("The parameter 'industryIds' cannot be null.");
        else if (industryIds !== undefined)
            industryIds && industryIds.forEach(item => { url_ += "IndustryIds=" + encodeURIComponent("" + item) + "&"; });
        if (cityIds === null)
            throw new globalThis.Error("The parameter 'cityIds' cannot be null.");
        else if (cityIds !== undefined)
            cityIds && cityIds.forEach(item => { url_ += "CityIds=" + encodeURIComponent("" + item) + "&"; });
        if (skillIds === null)
            throw new globalThis.Error("The parameter 'skillIds' cannot be null.");
        else if (skillIds !== undefined)
            skillIds && skillIds.forEach(item => { url_ += "SkillIds=" + encodeURIComponent("" + item) + "&"; });
        if (companyIds === null)
            throw new globalThis.Error("The parameter 'companyIds' cannot be null.");
        else if (companyIds !== undefined)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        if (desiredJobs === null)
            throw new globalThis.Error("The parameter 'desiredJobs' cannot be null.");
        else if (desiredJobs !== undefined)
            desiredJobs && desiredJobs.forEach(item => { url_ += "DesiredJobs=" + encodeURIComponent("" + item) + "&"; });
        if (mostJobPosts === null)
            throw new globalThis.Error("The parameter 'mostJobPosts' cannot be null.");
        else if (mostJobPosts !== undefined)
            url_ += "MostJobPosts=" + encodeURIComponent("" + mostJobPosts) + "&";
        if (memberIds === null)
            throw new globalThis.Error("The parameter 'memberIds' cannot be null.");
        else if (memberIds !== undefined)
            memberIds && memberIds.forEach(item => { url_ += "MemberIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchCompaniesByTerm(_response);
        });
    }

    protected processSearchCompaniesByTerm(response: Response): Promise<CompanyDetailsListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyDetailsListModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyDetailsListModel>(null as any);
    }

    /**
     * Search Partner suggestions
     * @param query Search term
     * @return Success
     */
    searchSuggestionsPartnerTitles(query: string): Promise<CompanySuggestionProfileModel[]> {
        let url_ = this.baseUrl + "/marketplace/search/partners/suggestions?";
        if (query === undefined || query === null)
            throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchSuggestionsPartnerTitles(_response);
        });
    }

    protected processSearchSuggestionsPartnerTitles(response: Response): Promise<CompanySuggestionProfileModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanySuggestionProfileModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanySuggestionProfileModel[]>(null as any);
    }

    /**
     * Search Partners
     * @param pageNumber (optional) 
     * @param query (optional) 
     * @return Success
     */
    searchPartnersByTerm(pageNumber: number | undefined, query: string | undefined): Promise<PagedPartnersResponse> {
        let url_ = this.baseUrl + "/marketplace/search/partners?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchPartnersByTerm(_response);
        });
    }

    protected processSearchPartnersByTerm(response: Response): Promise<PagedPartnersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedPartnersResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedPartnersResponse>(null as any);
    }

    /**
     * Search Candidate suggestions
     * @param query Search term
     * @return Success
     */
    searchSuggestionsCandidates(query: string): Promise<CandidatesSuggestionModel[]> {
        let url_ = this.baseUrl + "/marketplace/search/candidates/suggestions?";
        if (query === undefined || query === null)
            throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchSuggestionsCandidates(_response);
        });
    }

    protected processSearchSuggestionsCandidates(response: Response): Promise<CandidatesSuggestionModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidatesSuggestionModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CandidatesSuggestionModel[]>(null as any);
    }

    /**
     * Search candidates
     * @param query (optional) 
     * @param pageNumber (optional) 
     * @param industryIds (optional) 
     * @param cityIds (optional) 
     * @param skillIds (optional) 
     * @param companyIds (optional) 
     * @param desiredJobs (optional) 
     * @param mostJobPosts (optional) 
     * @param memberIds (optional) 
     * @return Success
     */
    searchCandidates(query: string | undefined, pageNumber: number | undefined, industryIds: number[] | undefined, cityIds: number[] | undefined, skillIds: number[] | undefined, companyIds: string[] | undefined, desiredJobs: string[] | undefined, mostJobPosts: SortingEnum | undefined, memberIds: string[] | undefined): Promise<CandidatePagedResponseModel> {
        let url_ = this.baseUrl + "/marketplace/search/candidates?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (industryIds === null)
            throw new globalThis.Error("The parameter 'industryIds' cannot be null.");
        else if (industryIds !== undefined)
            industryIds && industryIds.forEach(item => { url_ += "IndustryIds=" + encodeURIComponent("" + item) + "&"; });
        if (cityIds === null)
            throw new globalThis.Error("The parameter 'cityIds' cannot be null.");
        else if (cityIds !== undefined)
            cityIds && cityIds.forEach(item => { url_ += "CityIds=" + encodeURIComponent("" + item) + "&"; });
        if (skillIds === null)
            throw new globalThis.Error("The parameter 'skillIds' cannot be null.");
        else if (skillIds !== undefined)
            skillIds && skillIds.forEach(item => { url_ += "SkillIds=" + encodeURIComponent("" + item) + "&"; });
        if (companyIds === null)
            throw new globalThis.Error("The parameter 'companyIds' cannot be null.");
        else if (companyIds !== undefined)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        if (desiredJobs === null)
            throw new globalThis.Error("The parameter 'desiredJobs' cannot be null.");
        else if (desiredJobs !== undefined)
            desiredJobs && desiredJobs.forEach(item => { url_ += "DesiredJobs=" + encodeURIComponent("" + item) + "&"; });
        if (mostJobPosts === null)
            throw new globalThis.Error("The parameter 'mostJobPosts' cannot be null.");
        else if (mostJobPosts !== undefined)
            url_ += "MostJobPosts=" + encodeURIComponent("" + mostJobPosts) + "&";
        if (memberIds === null)
            throw new globalThis.Error("The parameter 'memberIds' cannot be null.");
        else if (memberIds !== undefined)
            memberIds && memberIds.forEach(item => { url_ += "MemberIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchCandidates(_response);
        });
    }

    protected processSearchCandidates(response: Response): Promise<CandidatePagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidatePagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CandidatePagedResponseModel>(null as any);
    }

    /**
     * Save search preferred
     * @param body (optional) 
     * @return Success
     */
    saveSearchPreferred(body: PreferredSearchRequest | undefined): Promise<CreateEntityResult> {
        let url_ = this.baseUrl + "/marketplace/search/preferred";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveSearchPreferred(_response);
        });
    }

    protected processSaveSearchPreferred(response: Response): Promise<CreateEntityResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateEntityResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateEntityResult>(null as any);
    }

    /**
     * Remove search from preferred
     * @return No Content
     */
    removeSearchFromPreferred(searchId: string): Promise<void> {
        let url_ = this.baseUrl + "/marketplace/search/preferred/{searchId}";
        if (searchId === undefined || searchId === null)
            throw new globalThis.Error("The parameter 'searchId' must be defined.");
        url_ = url_.replace("{searchId}", encodeURIComponent("" + searchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveSearchFromPreferred(_response);
        });
    }

    protected processRemoveSearchFromPreferred(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get preferred searches paged
     * @param pageNumber (optional) 
     * @return Success
     */
    getPreferredSearchesPaged(searchType: PreferredSearchTypeEnum, pageNumber: number | undefined): Promise<PreferredSearchViewModelPagedResponseModel> {
        let url_ = this.baseUrl + "/marketplace/search/{searchType}/preferred/paged?";
        if (searchType === undefined || searchType === null)
            throw new globalThis.Error("The parameter 'searchType' must be defined.");
        url_ = url_.replace("{searchType}", encodeURIComponent("" + searchType));
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPreferredSearchesPaged(_response);
        });
    }

    protected processGetPreferredSearchesPaged(response: Response): Promise<PreferredSearchViewModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreferredSearchViewModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreferredSearchViewModelPagedResponseModel>(null as any);
    }

    /**
     * Get preferred searches result counts
     * @param ids (optional) 
     * @return Success
     */
    getPreferredSearchesResultCounts(ids: string[] | undefined): Promise<PreferredSearchResultCount[]> {
        let url_ = this.baseUrl + "/marketplace/search/preferred/result-counts?";
        if (ids === null)
            throw new globalThis.Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPreferredSearchesResultCounts(_response);
        });
    }

    protected processGetPreferredSearchesResultCounts(response: Response): Promise<PreferredSearchResultCount[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreferredSearchResultCount[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreferredSearchResultCount[]>(null as any);
    }

    /**
     * Get preferred search by id
     * @return Success
     */
    getPreferredSearchById(id: string): Promise<PreferredSearchViewModel> {
        let url_ = this.baseUrl + "/marketplace/search/preferred/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPreferredSearchById(_response);
        });
    }

    protected processGetPreferredSearchById(response: Response): Promise<PreferredSearchViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreferredSearchViewModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreferredSearchViewModel>(null as any);
    }

    /**
     * Get preferred searches
     * @return Success
     */
    getPreferredSearches(searchType: PreferredSearchTypeEnum): Promise<PreferredSearchViewModel[]> {
        let url_ = this.baseUrl + "/marketplace/search/{searchType}/preferred";
        if (searchType === undefined || searchType === null)
            throw new globalThis.Error("The parameter 'searchType' must be defined.");
        url_ = url_.replace("{searchType}", encodeURIComponent("" + searchType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPreferredSearches(_response);
        });
    }

    protected processGetPreferredSearches(response: Response): Promise<PreferredSearchViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreferredSearchViewModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreferredSearchViewModel[]>(null as any);
    }

    /**
     * Search Corporate TA Company suggestions
     * @param query Search term
     * @return Success
     */
    searchSuggestionsCorporateTACompanyTitles(query: string): Promise<CompanySuggestionProfileModel[]> {
        let url_ = this.baseUrl + "/marketplace/search/corporate-companies/suggestions?";
        if (query === undefined || query === null)
            throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchSuggestionsCorporateTACompanyTitles(_response);
        });
    }

    protected processSearchSuggestionsCorporateTACompanyTitles(response: Response): Promise<CompanySuggestionProfileModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanySuggestionProfileModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanySuggestionProfileModel[]>(null as any);
    }

    /**
     * Search Corporate TA companies
     * @param query (optional) 
     * @param pageNumber (optional) 
     * @param industryIds (optional) 
     * @param cityIds (optional) 
     * @param skillIds (optional) 
     * @param companyIds (optional) 
     * @param desiredJobs (optional) 
     * @param mostJobPosts (optional) 
     * @param memberIds (optional) 
     * @return Success
     */
    searchCorporateTACompaniesByTerm(query: string | undefined, pageNumber: number | undefined, industryIds: number[] | undefined, cityIds: number[] | undefined, skillIds: number[] | undefined, companyIds: string[] | undefined, desiredJobs: string[] | undefined, mostJobPosts: SortingEnum | undefined, memberIds: string[] | undefined): Promise<CompanyDetailsListModel> {
        let url_ = this.baseUrl + "/marketplace/search/corporate-companies?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (industryIds === null)
            throw new globalThis.Error("The parameter 'industryIds' cannot be null.");
        else if (industryIds !== undefined)
            industryIds && industryIds.forEach(item => { url_ += "IndustryIds=" + encodeURIComponent("" + item) + "&"; });
        if (cityIds === null)
            throw new globalThis.Error("The parameter 'cityIds' cannot be null.");
        else if (cityIds !== undefined)
            cityIds && cityIds.forEach(item => { url_ += "CityIds=" + encodeURIComponent("" + item) + "&"; });
        if (skillIds === null)
            throw new globalThis.Error("The parameter 'skillIds' cannot be null.");
        else if (skillIds !== undefined)
            skillIds && skillIds.forEach(item => { url_ += "SkillIds=" + encodeURIComponent("" + item) + "&"; });
        if (companyIds === null)
            throw new globalThis.Error("The parameter 'companyIds' cannot be null.");
        else if (companyIds !== undefined)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        if (desiredJobs === null)
            throw new globalThis.Error("The parameter 'desiredJobs' cannot be null.");
        else if (desiredJobs !== undefined)
            desiredJobs && desiredJobs.forEach(item => { url_ += "DesiredJobs=" + encodeURIComponent("" + item) + "&"; });
        if (mostJobPosts === null)
            throw new globalThis.Error("The parameter 'mostJobPosts' cannot be null.");
        else if (mostJobPosts !== undefined)
            url_ += "MostJobPosts=" + encodeURIComponent("" + mostJobPosts) + "&";
        if (memberIds === null)
            throw new globalThis.Error("The parameter 'memberIds' cannot be null.");
        else if (memberIds !== undefined)
            memberIds && memberIds.forEach(item => { url_ += "MemberIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchCorporateTACompaniesByTerm(_response);
        });
    }

    protected processSearchCorporateTACompaniesByTerm(response: Response): Promise<CompanyDetailsListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyDetailsListModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyDetailsListModel>(null as any);
    }

    /**
     * Search all companies suggestions
     * @param query Search term
     * @param mostJobPosts (optional) 
     * @return Success
     */
    searchSuggestionsCompaniesTitles(query: string, mostJobPosts: SortingEnum | undefined): Promise<CompanySuggestionProfileModel[]> {
        let url_ = this.baseUrl + "/marketplace/search/companies/all/suggestions?";
        if (query === undefined || query === null)
            throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (mostJobPosts === null)
            throw new globalThis.Error("The parameter 'mostJobPosts' cannot be null.");
        else if (mostJobPosts !== undefined)
            url_ += "mostJobPosts=" + encodeURIComponent("" + mostJobPosts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchSuggestionsCompaniesTitles(_response);
        });
    }

    protected processSearchSuggestionsCompaniesTitles(response: Response): Promise<CompanySuggestionProfileModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanySuggestionProfileModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanySuggestionProfileModel[]>(null as any);
    }

    /**
     * Search all companies
     * @param query (optional) 
     * @param pageNumber (optional) 
     * @param industryIds (optional) 
     * @param cityIds (optional) 
     * @param skillIds (optional) 
     * @param companyIds (optional) 
     * @param desiredJobs (optional) 
     * @param mostJobPosts (optional) 
     * @param memberIds (optional) 
     * @return Success
     */
    searchAllCompaniesByTerm(query: string | undefined, pageNumber: number | undefined, industryIds: number[] | undefined, cityIds: number[] | undefined, skillIds: number[] | undefined, companyIds: string[] | undefined, desiredJobs: string[] | undefined, mostJobPosts: SortingEnum | undefined, memberIds: string[] | undefined): Promise<CompanyDetailsListModel> {
        let url_ = this.baseUrl + "/marketplace/search/companies/all?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (industryIds === null)
            throw new globalThis.Error("The parameter 'industryIds' cannot be null.");
        else if (industryIds !== undefined)
            industryIds && industryIds.forEach(item => { url_ += "IndustryIds=" + encodeURIComponent("" + item) + "&"; });
        if (cityIds === null)
            throw new globalThis.Error("The parameter 'cityIds' cannot be null.");
        else if (cityIds !== undefined)
            cityIds && cityIds.forEach(item => { url_ += "CityIds=" + encodeURIComponent("" + item) + "&"; });
        if (skillIds === null)
            throw new globalThis.Error("The parameter 'skillIds' cannot be null.");
        else if (skillIds !== undefined)
            skillIds && skillIds.forEach(item => { url_ += "SkillIds=" + encodeURIComponent("" + item) + "&"; });
        if (companyIds === null)
            throw new globalThis.Error("The parameter 'companyIds' cannot be null.");
        else if (companyIds !== undefined)
            companyIds && companyIds.forEach(item => { url_ += "CompanyIds=" + encodeURIComponent("" + item) + "&"; });
        if (desiredJobs === null)
            throw new globalThis.Error("The parameter 'desiredJobs' cannot be null.");
        else if (desiredJobs !== undefined)
            desiredJobs && desiredJobs.forEach(item => { url_ += "DesiredJobs=" + encodeURIComponent("" + item) + "&"; });
        if (mostJobPosts === null)
            throw new globalThis.Error("The parameter 'mostJobPosts' cannot be null.");
        else if (mostJobPosts !== undefined)
            url_ += "MostJobPosts=" + encodeURIComponent("" + mostJobPosts) + "&";
        if (memberIds === null)
            throw new globalThis.Error("The parameter 'memberIds' cannot be null.");
        else if (memberIds !== undefined)
            memberIds && memberIds.forEach(item => { url_ += "MemberIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchAllCompaniesByTerm(_response);
        });
    }

    protected processSearchAllCompaniesByTerm(response: Response): Promise<CompanyDetailsListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyDetailsListModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyDetailsListModel>(null as any);
    }

    /**
     * Get skills
     * @return Success
     */
    getListSkills(): Promise<SkillEntity[]> {
        let url_ = this.baseUrl + "/marketplace/catalogs/skills";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetListSkills(_response);
        });
    }

    protected processGetListSkills(response: Response): Promise<SkillEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SkillEntity[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SkillEntity[]>(null as any);
    }

    /**
     * Get link and key for upload document file
     * @param document_ext Extension for file, one of [doc, docx, pdf, rtf]
     * @return Success
     */
    getStorageUploadDocumentLink(document_ext: string): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/marketplace/storage/upload/document-file?";
        if (document_ext === undefined || document_ext === null)
            throw new globalThis.Error("The parameter 'document_ext' must be defined and cannot be null.");
        else
            url_ += "document-ext=" + encodeURIComponent("" + document_ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStorageUploadDocumentLink(_response);
        });
    }

    protected processGetStorageUploadDocumentLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Get link and key for upload document file
     * @param image_ext (optional) Extension for file, one of [jpg, jpeg, png]
     * @return Success
     */
    getStorageUploadImageLink(image_ext: string | undefined): Promise<S3UploadResponse> {
        let url_ = this.baseUrl + "/marketplace/storage/upload/image-file?";
        if (image_ext === null)
            throw new globalThis.Error("The parameter 'image_ext' cannot be null.");
        else if (image_ext !== undefined)
            url_ += "image-ext=" + encodeURIComponent("" + image_ext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStorageUploadImageLink(_response);
        });
    }

    protected processGetStorageUploadImageLink(response: Response): Promise<S3UploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3UploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3UploadResponse>(null as any);
    }

    /**
     * Teammates
     * @param pageNumber (optional) 
     * @return Success
     */
    getTeammates(pageNumber: number | undefined): Promise<TeammateModelPagedResponseModel> {
        let url_ = this.baseUrl + "/marketplace/account/teammates?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTeammates(_response);
        });
    }

    protected processGetTeammates(response: Response): Promise<TeammateModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TeammateModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeammateModelPagedResponseModel>(null as any);
    }

    /**
     * Edit Teammate
     * @param body (optional) 
     * @return Success
     */
    editTeammate(body: UpdateTeammateModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/account/teammates/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditTeammate(_response);
        });
    }

    protected processEditTeammate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Delete Teammate
     * @param body (optional) 
     * @return Success
     */
    deleteRegisteredTeammate(body: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/account/teammates/delete-registered";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteRegisteredTeammate(_response);
        });
    }

    protected processDeleteRegisteredTeammate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Delete Teammate
     * @param body (optional) 
     * @return Success
     */
    deleteUnregisteredTeammate(body: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/marketplace/account/teammates/delete-unregistered";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUnregisteredTeammate(_response);
        });
    }

    protected processDeleteUnregisteredTeammate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * GetTeammatesWithParent
     * @return Success
     */
    getTeammatesWithParent(): Promise<MPUserShortViewModel[]> {
        let url_ = this.baseUrl + "/marketplace/account/teammates/teammates-with-parent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTeammatesWithParent(_response);
        });
    }

    protected processGetTeammatesWithParent(response: Response): Promise<MPUserShortViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MPUserShortViewModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MPUserShortViewModel[]>(null as any);
    }

    /**
     * Partners dashboard. My partners.
     * @param pageSize (optional) 
     * @return Success
     */
    getMyRejectedCandidate(pageSize: number | undefined): Promise<JobCandidateDashboardViewModelTopListResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboards/todo/candidate/declined?";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyRejectedCandidate(_response);
        });
    }

    protected processGetMyRejectedCandidate(response: Response): Promise<JobCandidateDashboardViewModelTopListResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobCandidateDashboardViewModelTopListResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobCandidateDashboardViewModelTopListResponseModel>(null as any);
    }

    /**
     * Get received candidates
     * @param pageSize (optional) 
     * @return Success
     */
    getReceivedCandidates(pageSize: number | undefined): Promise<JobCandidateDashboardViewModelTopListResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboards/todo/candidates/received?";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReceivedCandidates(_response);
        });
    }

    protected processGetReceivedCandidates(response: Response): Promise<JobCandidateDashboardViewModelTopListResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobCandidateDashboardViewModelTopListResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobCandidateDashboardViewModelTopListResponseModel>(null as any);
    }

    /**
     * Get Interviews Requested
     * @param pageNumber (optional) 
     * @param isAscending (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getInterviewsRequested(pageNumber: number | undefined, isAscending: boolean | undefined, pageSize: number | undefined): Promise<JobCandidateDashboardViewModelTopListResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboards/todo/candidates/interviews?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (isAscending === null)
            throw new globalThis.Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "isAscending=" + encodeURIComponent("" + isAscending) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInterviewsRequested(_response);
        });
    }

    protected processGetInterviewsRequested(response: Response): Promise<JobCandidateDashboardViewModelTopListResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobCandidateDashboardViewModelTopListResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobCandidateDashboardViewModelTopListResponseModel>(null as any);
    }

    /**
     * Offers Extended to My Candidates
     * @param pageNumber (optional) 
     * @param isAscending (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getSubmittedCandidateOffersMade(pageNumber: number | undefined, isAscending: boolean | undefined, pageSize: number | undefined): Promise<JobCandidateDashboardViewModelTopListResponseModel> {
        let url_ = this.baseUrl + "/marketplace/dashboards/todo/candidates/offers-made?";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (isAscending === null)
            throw new globalThis.Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "isAscending=" + encodeURIComponent("" + isAscending) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubmittedCandidateOffersMade(_response);
        });
    }

    protected processGetSubmittedCandidateOffersMade(response: Response): Promise<JobCandidateDashboardViewModelTopListResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobCandidateDashboardViewModelTopListResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobCandidateDashboardViewModelTopListResponseModel>(null as any);
    }
}

export interface AcceptablePermissionEntity {
    id?: number;
    name?: string | undefined;
}

export interface AddMyCompanyExternalRequest {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    companyName?: string | undefined;
}

export interface AddMyCompanyPartnerRequest {
    invitedCompanyId?: string;
    invitationMessage?: string | undefined;
}

export enum AvailabilityTypeEnum {
    Days = 1,
    Weeks = 2,
}

export interface BaseAddressModel {
    address: string;
    city: string;
    state: string;
    zip: string;
}

export interface BaseCompanyCountersModel {
    jobsPosted: number;
    partnersInNetwork: number;
}

export interface BasePartnerStatusModel {
    status?: PartnerStatusEnum;
    partnerInvitationId?: string | undefined;
}

export interface BenefitEntity {
    id?: number;
    name?: string | undefined;
}

export interface CandidateDetailPieChartResponseModel {
    jobTotalCount?: number;
    candidateTotalCount?: number;
    jobDetails?: JobCandidatePieChartViewModel[] | undefined;
}

export interface CandidateModel {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    rateValue?: number;
    rateType?: RateTypeEnum;
    summary?: string | undefined;
    stateId?: number | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    cvPath?: string | undefined;
    educationId?: number | undefined;
    yearsExperienceId?: number | undefined;
    certifications?: string[] | undefined;
    hasSponsor?: boolean;
    acceptablePermissions?: string[] | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    availabilityValue?: number | undefined;
    availabilityType?: AvailabilityTypeEnum;
    skills?: string[] | undefined;
    desiredJob?: string | undefined;
    visibility?: CandidateVisibilityEnum;
    isBlurred?: boolean;
    isHidden?: boolean;
}

export interface CandidateNoteDetailModel {
    id?: string;
    candidateId?: string;
    content?: string | undefined;
    userId?: string;
    companyId?: string;
    creatorFullName?: string | undefined;
    createdDate?: Date;
}

export interface CandidateNoteDetailModelPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: CandidateNoteDetailModel[] | undefined;
}

export interface CandidatePagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: CandidateResponseModel[] | undefined;
}

export interface CandidatePreferencesRequestModel {
    desiredJobs?: string[] | undefined;
    cities?: number[] | undefined;
    skills?: number[] | undefined;
}

export interface CandidatePreferencesResponseModel {
    desiredJobs?: string[] | undefined;
    cities?: CityEntity[] | undefined;
    skills?: SkillEntity[] | undefined;
}

export interface CandidateProfileModel {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    summary?: string | undefined;
    visibility?: CandidateVisibilityEnum;
}

export interface CandidateReasonEntity {
    id?: number;
    name?: string | undefined;
}

export interface CandidateRequestResponseModel {
    jobCandidateId?: string;
    candidateId?: string;
    status?: CandidateStatusEnum;
    createdDate?: Date;
    companyId?: string;
    companyName?: string | undefined;
    jobId?: string;
}

export interface CandidateResponseModel {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    rateValue?: number;
    rateType?: RateTypeEnum;
    summary?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    countryId?: number | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    cvPath?: string | undefined;
    createdDate?: Date;
    educationId?: number | undefined;
    yearsExperienceId?: number | undefined;
    stateId?: number;
    hasSponsor?: boolean;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    availabilityValue?: number | undefined;
    availabilityType?: AvailabilityTypeEnum;
    education?: string | undefined;
    yearsExperience?: string | undefined;
    keyHighlights?: string | undefined;
    departmentId?: string | undefined;
    departmentName?: string | undefined;
    skills?: string[] | undefined;
    acceptablePermissions?: string[] | undefined;
    certifications?: string[] | undefined;
    companyData?: CompanyMiniModel;
    desiredJobs?: string[] | undefined;
    visibility?: CandidateVisibilityEnum;
    isBlurred?: boolean;
    isHidden?: boolean;
    isMyCandidate?: boolean;
    isSubmitted?: boolean;
    isOfferAccepted?: boolean;
    creator?: CreatorUserModel;
    isHighlight?: boolean;
    jobCandidateId?: string | undefined;
}

export interface CandidateShortInfoResponseModel {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    createdDate?: Date;
    rateValue?: number;
    rateType?: RateTypeEnum;
    desiredJobs?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    hasSponsor?: boolean;
    email?: string | undefined;
    visibility?: CandidateVisibilityEnum;
}

export interface CandidateShortInfoResponseModelPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: CandidateShortInfoResponseModel[] | undefined;
}

export enum CandidateStageStatusEnum {
    Completed = 1,
    Declined = 2,
}

export enum CandidateStatusEnum {
    All = 0,
    Pending = 1,
    Accepted = 2,
    ScreeningCompleted = 3,
    InterviewRequested = 4,
    AllInterviewsCompleted = 5,
    OfferMade = 6,
    OfferAccepted = 7,
    Withdrawn = 8,
    Declined = 9,
}

export enum CandidateVisibilityEnum {
    Public = 1,
    Private = 2,
}

export interface CandidateWithdrawRequestModel {
    jobCandidateId?: string;
    reasonTypeId?: number;
    reasonValue?: string | undefined;
}

export interface CandidatesPieChartModel {
    totalCandidates?: number;
    percentCandidates?: number;
}

export interface CandidatesPieChartResponseModel {
    totalCandidates?: number;
    pendingCandidates?: CandidatesPieChartModel;
    acceptedCandidates?: CandidatesPieChartModel;
    declinedCandidates?: CandidatesPieChartModel;
}

export interface CandidatesSuggestionModel {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    desiredJobs?: string[] | undefined;
}

export interface CertificationEntity {
    id?: number;
    name?: string | undefined;
}

export interface ChartsModel {
    counter?: number;
    periodType?: ChartsPeriodDayEnum;
}

export enum ChartsPeriodDayEnum {
    AM12 = 1,
    AM2 = 2,
    AM4 = 3,
    AM6 = 4,
    AM8 = 5,
    AM10 = 6,
    PM12 = 7,
    PM2 = 8,
    PM4 = 9,
    PM6 = 10,
    PM8 = 11,
    PM10 = 12,
}

export interface CheckUniqueCompanyNameResponse {
    companyName?: string | undefined;
    isUnique?: boolean;
}

export interface CityEntity {
    id?: number;
    stateId?: number;
    name?: string | undefined;
}

export interface CompanyCandidateViewModel {
    companyId?: string;
    companyName?: string | undefined;
    candidateCount?: number;
}

export interface CompanyDetailsListModel {
    totalCount?: number;
    pageNumber?: number;
    details?: CompanySearchResultModel[] | undefined;
}

export interface CompanyDictionaryModel {
    companyId?: string;
    companyName?: string | undefined;
}

export interface CompanyMiniModel {
    companyId?: string;
    companyName?: string | undefined;
    logoUrl?: string | undefined;
    counters?: BaseCompanyCountersModel;
}

export interface CompanyProfileEditModel {
    companyName?: string | undefined;
    address?: string | undefined;
    cityName?: string | undefined;
    stateId?: number;
    zip?: string | undefined;
    companyWebsite?: string | undefined;
    companyAbout?: string | undefined;
    companySizeId?: number | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    contactEmail?: string | undefined;
    contactPhoneNumber?: string | undefined;
    skills?: string[] | undefined;
    visibilityType?: CompanyVisibilityEnum;
    logoImageKey?: string | undefined;
    backgroundImageKey?: string | undefined;
}

export interface CompanyProfileEditViewModel {
    companyId?: string;
    stateName?: string | undefined;
    companySizeName?: string | undefined;
    companyName?: string | undefined;
    address?: string | undefined;
    cityName?: string | undefined;
    stateId?: number;
    zip?: string | undefined;
    companyWebsite?: string | undefined;
    companyAbout?: string | undefined;
    companySizeId?: number | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    contactEmail?: string | undefined;
    contactPhoneNumber?: string | undefined;
    skills?: string[] | undefined;
    visibilityType?: CompanyVisibilityEnum;
    logoImageKey?: string | undefined;
    backgroundImageKey?: string | undefined;
}

export interface CompanyProfilePresentationModel {
    companyId: string;
    backgroundUrl: string;
    logoUrl: string;
    logoImageKey: string;
    backgroundImageKey: string;
    companyName: string;
    isPartner: boolean;
    isPreferred?: boolean | undefined;
    preferredDateTime?: Date | undefined;
    memberSince: Date;
    location: BaseAddressModel;
    counters?: BaseCompanyCountersModel;
    partnerStatus?: BasePartnerStatusModel;
    website?: string | undefined;
    companyAbout?: string | undefined;
    companySizeId?: number | undefined;
    companySizeName?: string | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    contactEmail?: string | undefined;
    contactPhoneNumber?: string | undefined;
    representativeFirstName?: string | undefined;
    representativeLastName?: string | undefined;
    representativeEmail?: string | undefined;
    profileType?: ProfileTypeEnum;
    skills?: string[] | undefined;
    isFollowed?: boolean;
}

export interface CompanySearchResultModel {
    companyId: string;
    logoUrl: string;
    backgroundUrl: string;
    companyName: string;
    isPartner?: boolean;
    isPreferred?: boolean | undefined;
    preferredDateTime?: Date | undefined;
    memberSince: Date;
    location: BaseAddressModel;
    jobsPosted: number;
    partnersInNetwork: number;
    skills?: string[] | undefined;
    primaryContactFirstName?: string | undefined;
    primaryContactLastName?: string | undefined;
    primaryContactEmail?: string | undefined;
    partnerStatus?: BasePartnerStatusModel;
}

export interface CompanySizeModel {
    id?: number;
    name: string;
}

export interface CompanySuggestionProfileModel {
    companyId: string;
    logoUrl: string;
    companyName: string;
    memberSince: Date;
}

export enum CompanyVisibilityEnum {
    VisibilityToAll = 1,
    VisibilityToPartnersOnly = 2,
}

export interface CountryEntity {
    id?: number;
    name?: string | undefined;
}

export interface CreateCompanyModel {
    companyName: string;
    companyWebsite?: string | undefined;
    stateId: number;
    city: string;
}

export interface CreateDepartmentModel {
    name?: string | undefined;
    headDepartment?: string | undefined;
    headDepartmentEmail?: string | undefined;
    assignedRecruiter?: string | undefined;
}

export interface CreateEntityResult {
    createdId?: string;
}

export interface CreateNewCandidateNoteRequest {
    content?: string | undefined;
    candidateId?: string;
}

export interface CreateNewJobNoteRequest {
    content?: string | undefined;
    jobId?: string;
}

export interface CreateNewPostRequest {
    content?: string | undefined;
    imageS3Key?: string | undefined;
}

export interface CreatorUserModel {
    id?: string;
    fullName?: string | undefined;
}

export enum DashboardDurationEnum {
    AllPeriod = 0,
    Day = 1,
    Week = 2,
    Month = 3,
    Year = 4,
}

export interface DateTimeModel {
    id?: string | undefined;
    date?: Date | undefined;
    time?: string | undefined;
    timeZone?: string | undefined;
}

export interface DepartmentEntity {
    departmentId?: string;
    name?: string | undefined;
    headDepartment?: string | undefined;
    headDepartmentEmail?: string | undefined;
    assignedRecruiter?: string | undefined;
    creatorCompanyId?: string;
    createdDate?: Date;
}

export interface DepartmentSimpleViewModel {
    departmentId?: string;
    name?: string | undefined;
}

export interface DepartmentViewModel {
    departmentId?: string;
    name?: string | undefined;
    headDepartment?: string | undefined;
    headDepartmentEmail?: string | undefined;
    assignedRecruiter?: string | undefined;
    creatorCompanyId?: string;
    createdDate?: Date;
    jobsCount?: number;
    candidatesCount?: number;
}

export interface DepartmentViewModelPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: DepartmentViewModel[] | undefined;
}

export enum DurationTypeEnum {
    Week = 1,
    Month = 2,
    Year = 3,
}

export interface EditCandidateNoteRequest {
    content?: string | undefined;
    candidateNoteId?: string;
}

export interface EditJobNoteRequest {
    content?: string | undefined;
    jobNoteId?: string;
}

export interface EducationEntity {
    id?: number;
    name?: string | undefined;
}

export interface EntityListItemViewModel {
    id?: string;
    title?: string | undefined;
}

export interface FollowerCompanyItemViewModel {
    companyId?: string;
    companyName?: string | undefined;
    logoUrl?: string | undefined;
    createdDate?: Date;
    jobsPostedCount?: number;
    location?: BaseAddressModel;
    skills?: string[] | undefined;
}

export interface FollowerCompanyItemViewModelPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: FollowerCompanyItemViewModel[] | undefined;
}

export interface IndustryEntity {
    id?: number;
    name?: string | undefined;
}

export interface InitialProfileRequestModel {
    profileType?: ProfileTypeEnum;
    companyInfo?: CreateCompanyModel;
    representativeInfo?: RepresentativeInfoModel;
}

export interface InternationalCityEntity {
    id?: number;
    countryId?: number;
    name?: string | undefined;
}

export interface InterviewReplyRequestModel {
    interviewId?: string;
    selectedDatetimeId?: string | undefined;
    replyNotes?: string | undefined;
    inviteLink?: string | undefined;
}

export enum InterviewTypeEnum {
    InterviewRequested = 1,
}

export enum InvitationStatusEnum {
    Pending = 0,
    Accepted = 1,
    Withdrawn = -2,
    Declined = -1,
}

export enum InvitationStatusFilterEnum {
    All = "All",
    Pending = "Pending",
    Accepted = "Accepted",
    Declined = "Declined",
}

export interface InvitedUserDetailEntity {
    isInvitedUser?: boolean;
    isRegistred?: boolean;
}

export interface JobAssignedChartResponseModel {
    jobAssignedCount?: number;
    companyCount?: number;
    chartsData?: ChartsModel[] | undefined;
}

export interface JobAssignedViewModel {
    companyId?: string;
    companyName?: string | undefined;
    jobAssignedCount?: number;
}

export interface JobCandidateApproveStepModel {
    jobCandidateId?: string;
    currentStage?: CandidateStatusEnum;
    currentStageStatus?: CandidateStageStatusEnum;
    reasonTypeId?: number | undefined;
    reasonValue?: string | undefined;
}

export interface JobCandidateDashboardViewModel {
    jobCandidateId?: string;
    jobId?: string;
    candidateId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    companyName?: string | undefined;
    senderCompanyName?: string | undefined;
    date?: Date;
    jobTitle?: string | undefined;
    isHidden?: boolean;
    setStatusDate?: Date;
    interviewDate?: Date | undefined;
    interviewTime?: string | undefined;
    interviewTimeZone?: string | undefined;
}

export interface JobCandidateDashboardViewModelTopListResponseModel {
    totalCount?: number;
    details?: JobCandidateDashboardViewModel[] | undefined;
}

export interface JobCandidateInterviewReplyModel {
    replyNotes?: string | undefined;
    replyDate?: Date | undefined;
    selectedDate?: DateTimeModel;
    inviteLink?: string | undefined;
}

export interface JobCandidateInterviewResponseModel {
    id?: string;
    dates?: DateTimeModel[] | undefined;
    notes?: string | undefined;
    type?: InterviewTypeEnum;
    jobCandidateId?: string;
    memberId?: string;
    memberProfileType?: ProfileTypeEnum;
    memberCompanyName?: string | undefined;
    reply?: JobCandidateInterviewReplyModel;
}

export interface JobCandidateMatchModel {
    id?: string;
    candidate?: CandidateResponseModel;
    isSaved?: boolean;
    createdDate?: Date;
}

export interface JobCandidateMatchesModel {
    job?: JobDetailResponseModel;
    candidateMatches?: JobCandidateMatchModel[] | undefined;
    totalCount?: number;
    unsavedCandidatesCount?: number;
}

export interface JobCandidatePieChartViewModel {
    jobId?: string;
    jobTitle?: string | undefined;
    candidateCount?: number;
    percentCandidate?: number;
}

export interface JobCandidateResponse {
    id?: string;
    candidateId?: string;
    photoUrl?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    companyData?: CompanyMiniModel;
    jobData?: JobPresentationResponseModel;
    status?: CandidateStatusEnum;
    state?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    rateValue?: number;
    rateType?: RateTypeEnum;
    updatedDate?: Date;
    createdDate?: Date;
    skills?: string[] | undefined;
    acceptablePermissions?: string[] | undefined;
    certifications?: string[] | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    education?: string | undefined;
    yearsExperience?: string | undefined;
    keyHighlights?: string | undefined;
    isMyCandidate?: boolean;
    isShowActions?: boolean;
    availabilityType?: number;
    availabilityValue?: number;
    reasonType?: string | undefined;
    reasonValue?: string | undefined;
    stages?: JobCandidateStageModel[] | undefined;
    hasCVDownload?: boolean;
    originalCandidate?: OriginalCandidateRequestModel;
    departmentId?: string | undefined;
    departmentName?: string | undefined;
    interviews?: JobCandidateInterviewResponseModel[] | undefined;
    indicatorStages?: CandidateStatusEnum[] | undefined;
    visibility?: CandidateVisibilityEnum;
    hasSponsor?: boolean;
    desiredJobs?: string[] | undefined;
    isBlurred?: boolean;
    isHidden?: boolean;
    creator?: CreatorUserModel;
    isHighlight?: boolean;
}

export interface JobCandidateStageModel {
    stage?: CandidateStatusEnum;
    stageStatus?: CandidateStageStatusEnum;
}

export interface JobCandidatesSummaryModel {
    jobId?: string;
    jobKey?: string | undefined;
    jobTitle?: string | undefined;
    candidateTotalCount?: number;
    datePosted?: Date;
    expirationDate?: Date;
    createdDate?: Date;
}

export interface JobCandidatesSummaryModelTopListResponseModel {
    totalCount?: number;
    details?: JobCandidatesSummaryModel[] | undefined;
}

export interface JobChartDetailsViewModel {
    id?: string;
    jobKey?: string | undefined;
    title?: string | undefined;
    locationType?: LocationTypeEnum;
    stateId?: number | undefined;
    state?: string | undefined;
    cityId?: number | undefined;
    city?: string | undefined;
    address?: string | undefined;
    zip?: string | undefined;
    jobContractType?: JobContractTypeEnum;
    publishDate?: Date;
    totalCandidatesCount?: number;
    pendingCandidatesCount?: number;
    acceptedCandidatesCount?: number;
    declinedCandidatesCount?: number;
}

export enum JobContractTypeEnum {
    Contractor = 1,
    ContractToHire = 2,
    Permanent = 3,
}

export enum JobCorporateVisibilityEnum {
    OpenToAll = 1,
    OpenToSpecificMembers = 2,
    OpenToSpecificPartners = 3,
    Private = 4,
    OpenToPreferredPartners = 5,
}

export interface JobDetailListModel {
    details?: JobDetailResponseModel[] | undefined;
    totalCount?: number;
    pageNumber?: number;
}

export interface JobDetailResponseModel {
    id?: string;
    title: string;
    templateName?: string | undefined;
    description?: string | undefined;
    jobContractType: JobContractTypeEnum;
    availablePositions: number;
    durationNum: number;
    durationType: number;
    billRate?: number | undefined;
    minBillRate?: number | undefined;
    maxBillRate?: number | undefined;
    payRate?: number | undefined;
    minSalary?: number | undefined;
    maxSalary?: number | undefined;
    feePercent?: number | undefined;
    feeAmount?: number | undefined;
    locationType: LocationTypeEnum;
    allowNonLocalCandidates: boolean;
    stateId?: number | undefined;
    state?: string | undefined;
    cityId?: number | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    country?: string | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    address?: string | undefined;
    referenceNumber?: string | undefined;
    zip?: string | undefined;
    industry?: string | undefined;
    educationId?: number | undefined;
    yearsExperienceId?: number | undefined;
    jobExpirationId?: number;
    jobExpirationDate?: Date | undefined;
    creator?: CreatorUserModel;
    hasSponsor?: boolean;
    skills?: string[] | undefined;
    jobTeammates?: MPUserShortViewModel[] | undefined;
    specializations?: string[] | undefined;
    requiredQualifications?: string[] | undefined;
    preferredQualifications?: string[] | undefined;
    preferredSkills?: string[] | undefined;
    acceptablePermissions?: string[] | undefined;
    certifications?: string[] | undefined;
    benefits?: string[] | undefined;
    selectedPartners?: PartnerSelectModel[] | undefined;
    startDate?: Date | undefined;
    createdDate?: Date;
    publishStatus?: JobPublishStatus;
    candidatesCount?: number | undefined;
    isMyJob?: boolean;
    visibilityType: JobVisibilityEnum;
    viewsCount?: number;
    isCanBePublished?: boolean;
    companyData?: CompanySearchResultModel;
    isBlurred?: boolean;
    numberOfPlacementsType?: NumberOfPlacementsEnum;
    corporateVisibilityType?: JobCorporateVisibilityEnum;
    profileType?: JobProfileTypeEnum;
    maxNumberOfCandidatesType?: MaxNumberOfCandidatesEnum;
    departmentId?: string | undefined;
    departmentName?: string | undefined;
}

export interface JobDraftModel {
    availablePositions?: number | undefined;
    durationNum?: number | undefined;
    durationType?: DurationTypeEnum;
    billRate?: number | undefined;
    payRate?: number | undefined;
    minSalary?: number | undefined;
    maxSalary?: number | undefined;
    stateId?: number | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    jobExpirationId?: number;
    jobTeammates?: string[] | undefined;
    id?: string | undefined;
    title: string;
    isNeedCreateTemplate: boolean;
    templateId?: string | undefined;
    templateName?: string | undefined;
    description?: string | undefined;
    jobContractType: JobContractTypeEnum;
    minBillRate?: number | undefined;
    maxBillRate?: number | undefined;
    feePercent?: number | undefined;
    feeAmount?: number | undefined;
    locationType: LocationTypeEnum;
    allowNonLocalCandidates: boolean;
    address?: string | undefined;
    zip?: string | undefined;
    skills?: string[] | undefined;
    specializations?: string[] | undefined;
    preferredSkills?: string[] | undefined;
    requiredQualifications?: string[] | undefined;
    preferredQualifications?: string[] | undefined;
    industry?: string | undefined;
    educationId?: number;
    yearsExperienceId?: number;
    hasSponsor?: boolean;
    acceptablePermissions?: string[] | undefined;
    certifications?: string[] | undefined;
    benefits?: string[] | undefined;
    selectedPartners?: string[] | undefined;
    startDate?: Date | undefined;
    referenceNumber?: string | undefined;
    visibilityType: JobVisibilityEnum;
    lastActiveStatusDate?: Date;
    numberOfPlacementsType?: NumberOfPlacementsEnum;
    corporateVisibilityType?: JobCorporateVisibilityEnum;
    maxNumberOfCandidatesType?: MaxNumberOfCandidatesEnum;
    departmentId?: string | undefined;
}

export interface JobDuplicatedCandidateResponse {
    jobCandidateId?: string;
    candidateId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    companyName?: string | undefined;
    jobData?: JobPresentationResponseModel;
    status?: CandidateStatusEnum;
    state?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    rateValue?: number;
    rateType?: RateTypeEnum;
    hasSponsor?: boolean;
    updatedDate?: Date;
    createdDate?: Date;
    visibility?: CandidateVisibilityEnum;
    email?: string | undefined;
    stages?: JobCandidateStageModel[] | undefined;
    indicatorStages?: CandidateStatusEnum[] | undefined;
}

export interface JobExpirationEntity {
    id?: number;
    value?: number;
}

export interface JobFilterModel {
    jobId?: string;
    jobTitle?: string | undefined;
    city?: string | undefined;
}

export interface JobHasCandidatesResponseModel {
    hasPendingCandidates?: boolean;
    hasNoPendingCandidates?: boolean;
}

export interface JobModel {
    availablePositions: number;
    durationNum?: number | undefined;
    durationType?: DurationTypeEnum;
    billRate?: number | undefined;
    payRate?: number | undefined;
    minSalary?: number | undefined;
    maxSalary?: number | undefined;
    stateId?: number | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    internationalCityName?: string | undefined;
    internationalStateName?: string | undefined;
    jobTeammates?: string[] | undefined;
    jobExpirationId: number;
    id?: string | undefined;
    title: string;
    isNeedCreateTemplate: boolean;
    templateId?: string | undefined;
    templateName?: string | undefined;
    description?: string | undefined;
    jobContractType: JobContractTypeEnum;
    minBillRate?: number | undefined;
    maxBillRate?: number | undefined;
    feePercent?: number | undefined;
    feeAmount?: number | undefined;
    locationType: LocationTypeEnum;
    allowNonLocalCandidates: boolean;
    address?: string | undefined;
    zip?: string | undefined;
    skills?: string[] | undefined;
    specializations?: string[] | undefined;
    preferredSkills?: string[] | undefined;
    requiredQualifications?: string[] | undefined;
    preferredQualifications?: string[] | undefined;
    industry?: string | undefined;
    educationId?: number;
    yearsExperienceId?: number;
    hasSponsor?: boolean;
    acceptablePermissions?: string[] | undefined;
    certifications?: string[] | undefined;
    benefits?: string[] | undefined;
    selectedPartners?: string[] | undefined;
    startDate?: Date | undefined;
    referenceNumber?: string | undefined;
    visibilityType: JobVisibilityEnum;
    lastActiveStatusDate?: Date;
    numberOfPlacementsType?: NumberOfPlacementsEnum;
    corporateVisibilityType?: JobCorporateVisibilityEnum;
    maxNumberOfCandidatesType?: MaxNumberOfCandidatesEnum;
    departmentId?: string | undefined;
}

export interface JobNoteDetailModel {
    id?: string;
    jobId?: string;
    content?: string | undefined;
    userId?: string;
    companyId?: string;
    creatorFullName?: string | undefined;
    createdDate?: Date;
}

export interface JobNoteDetailModelPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: JobNoteDetailModel[] | undefined;
}

export interface JobPieChartDetailsResponseModel {
    totalJobs?: number;
    details?: JobChartDetailsViewModel[] | undefined;
}

export interface JobPieChartModel {
    totalJobs?: number;
    percentJobs?: number;
}

export interface JobPresentationResponseModel {
    jobId?: string;
    jobCompanyId?: string;
    companyName?: string | undefined;
    jobTitle?: string | undefined;
    publishStatus?: JobPublishStatus;
    createdDate?: Date;
    jobsPosted?: number;
    logoUrl?: string | undefined;
}

export enum JobProfileTypeEnum {
    Recruiter = 1,
    Corporate = 2,
}

export enum JobPublishStatus {
    Active = 1,
    InActive = 2,
    Draft = 3,
    Deleted = 4,
}

export enum JobSortFieldEnum {
    DatePosted = 1,
    MostSubmission = 2,
}

export interface JobSubmissionsResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: JobSubmissionsViewModel[] | undefined;
}

export interface JobSubmissionsViewModel {
    jobId?: string;
    jobTitle?: string | undefined;
    publishStatus?: JobPublishStatus;
    submissionsCount?: number;
}

export interface JobTemplateMiniViewModel {
    id?: string;
    templateName?: string | undefined;
}

export interface JobTitleEntity {
    id?: number;
    title?: string | undefined;
}

export interface JobTitlesTemplatesModel {
    jobTitleId?: number | undefined;
    jobTitle?: string | undefined;
    description?: string | undefined;
    industry?: string | undefined;
    requiredQualifications?: string[] | undefined;
    preferredQualifications?: string[] | undefined;
    requiredSkills?: string[] | undefined;
    preferredSkills?: string[] | undefined;
    benefitTypes?: string[] | undefined;
    certifications?: string[] | undefined;
    educationId?: number | undefined;
    yearsOfExperienceId?: number | undefined;
    createdDate?: Date;
}

export interface JobViewsResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: JobViewsViewModel[] | undefined;
}

export interface JobViewsViewModel {
    jobId?: string;
    jobTitle?: string | undefined;
    publishStatus?: JobPublishStatus;
    viewsCount?: number;
}

export enum JobVisibilityEnum {
    OpenToAll = 1,
    OpenToSpecificPartners = 2,
    OpenToAllPartners = 3,
    Private = 4,
    OpenToPreferredPartners = 5,
}

export interface JobsPieChartResponseModel {
    jobTotalCount?: number;
    jobContractor?: JobPieChartModel;
    jobContractToHire?: JobPieChartModel;
    jobPermanent?: JobPieChartModel;
}

export enum LocationTypeEnum {
    Onsite = 1,
    Remote = 2,
}

export interface MPMemberShortViewModel {
    companyId?: string;
    companyName?: string | undefined;
}

export interface MPUserShortViewModel {
    userId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export interface MarketplaceUserModel {
    userId?: string;
    companyId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    companyName?: string | undefined;
    userStatus?: UserStatusEnum;
    isProfileComplete?: boolean;
    roles?: string[] | undefined;
    profileType?: ProfileTypeEnum;
    logoUrl?: string | undefined;
    onboardingParams?: OnboardingModel;
}

export enum MaxNumberOfCandidatesEnum {
    Unlimited = 0,
    Max1 = 1,
    Max3 = 3,
    Max5 = 5,
    Max10 = 10,
    Max20 = 20,
}

export interface MyPartnersChartDetailsResponseModel {
    totalPartners?: number;
    details?: MyPartnersChartDetailsViewModel[] | undefined;
}

export interface MyPartnersChartDetailsViewModel {
    companyId?: string;
    companyName?: string | undefined;
    receivedCandidatesCount?: number;
    receivedAcceptedCandidatesCount?: number;
    receivedDeclinedCandidatesCount?: number;
    submittedCandidatesCount?: number;
    submittedAcceptedCandidatesCount?: number;
    submittedDeclinedCandidatesCount?: number;
    jobActiveCount?: number;
    assignedToMeJobCount?: number;
}

export interface MyPartnersChartResponseModel {
    totalPartners?: number;
    details?: MyPartnersChartViewModel[] | undefined;
}

export interface MyPartnersChartViewModel {
    companyId?: string;
    companyName?: string | undefined;
    submittedCandidatesCount?: number;
}

export enum NumberOfPlacementsEnum {
    All = 0,
    From0To10 = 10,
    From11To20 = 20,
    From21To50 = 50,
    From51To100 = 100,
    From101 = 1000000,
}

export interface OnboardingModel {
    isJobCandidateReviewed?: boolean;
    isJobCandidateSubmittedReviewed?: boolean;
    isRecievedJobCandidateSummaryReviewed?: boolean;
}

export interface OriginalCandidateRequestModel {
    jobCandidateId?: string;
    candidateId?: string | undefined;
    isHidden?: boolean | undefined;
}

export interface PagedCompanyCandidateResponseModel {
    totalCompanyCount?: number;
    totalCandidateCount?: number;
    pageNumber?: number;
    details?: CompanyCandidateViewModel[] | undefined;
}

export interface PagedCompanyRequestResponseModel {
    totalCandidateCount?: number;
    pageNumber?: number;
    totalCompanyCount?: number;
    details?: CandidateRequestResponseModel[] | undefined;
}

export interface PagedJobAssignedResponseModel {
    pageNumber?: number;
    totalCompanyCount?: number;
    totalJobAssignedCount?: number;
    details?: JobAssignedViewModel[] | undefined;
}

export interface PagedJobCandidateResponse {
    totalCount?: number;
    pageNumber?: number;
    details?: JobCandidateResponse[] | undefined;
}

export interface PagedJobDuplicatedCandidateResponse {
    totalCount?: number;
    pageNumber?: number;
    details?: JobDuplicatedCandidateResponse[] | undefined;
}

export interface PagedJobPostingsCreatedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: JobPresentationResponseModel[] | undefined;
}

export interface PagedPartnerInvitationResponse {
    totalCount?: number;
    pageNumber?: number;
    details?: PartnerInvitationResponse[] | undefined;
}

export interface PagedPartnersResponse {
    totalCount?: number;
    pageNumber?: number;
    details?: PartnerResponse[] | undefined;
}

export interface PagedPartnersSubmissionsResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: PartnersSubmissionsViewModel[] | undefined;
}

export interface PagedPartnershipRequestsResponseModel {
    totalPartnerCount?: number;
    pageNumber?: number;
    totalCompanyCount?: number;
    details?: PartnershipRequestsResponseModel[] | undefined;
}

export interface PartnerInvitationResponse {
    invitationId?: string;
    invitationStatus?: InvitationStatusEnum;
    invitationDate?: Date;
    company?: CompanySearchResultModel;
}

export interface PartnerResponse {
    companyPartnerId?: string;
    companyPartnerDate?: Date;
    company?: CompanySearchResultModel;
}

export interface PartnerSelectModel {
    companyId?: string;
    companyName?: string | undefined;
    isPreferred?: boolean;
    preferredDateTime?: Date | undefined;
    email?: string | undefined;
}

export enum PartnerStatusEnum {
    None = 0,
    Partner = 1,
    Submitted = 2,
    Received = 3,
}

export enum PartnersSubmissionsRequestEnum {
    Received = 1,
    Submitted = 2,
}

export interface PartnersSubmissionsResponseModel {
    submissionsCount?: number;
    partnersCount?: number;
    chartsData?: ChartsModel[] | undefined;
}

export interface PartnersSubmissionsViewModel {
    companyId?: string;
    companyName?: string | undefined;
    submissionCount?: number;
}

export interface PartnershipRequestsResponseModel {
    companyId?: string;
    companyName?: string | undefined;
    status?: InvitationStatusEnum;
    createdDate?: Date;
}

export interface PostCompanyInfoModel {
    companyId: string;
    companyName: string;
    memberSince: Date;
    logoUrl?: string | undefined;
}

export interface PostDetailModel {
    postId?: string;
    createdDate?: Date;
    content?: string | undefined;
    imageUrl?: string | undefined;
    companyInfo?: PostCompanyInfoModel;
    isMyPost?: boolean;
    isCreatedByAdmin?: boolean;
    postedJobDetail?: PostedJobDetail;
}

export interface PostResponseModel {
    total?: number;
    pageNumber?: number;
    details?: PostDetailModel[] | undefined;
}

export interface PostedJobDetail {
    jobId?: string;
    jobTitle?: string | undefined;
    jobType?: string | undefined;
    availablePositions?: number;
    companyName?: string | undefined;
    companyId?: string;
    companyLogoImageKey?: string | undefined;
    companyLogoUrl?: string | undefined;
}

export interface PreferredSearchFilters {
    query?: string | undefined;
    industryIds?: number[] | undefined;
    cityIds?: number[] | undefined;
    skillIds?: number[] | undefined;
    companyIds?: string[] | undefined;
    desiredJobs?: string[] | undefined;
}

export enum PreferredSearchNotificationFrequency {
    Instantly = 1,
    Daily = 2,
    Weekly = 3,
}

export interface PreferredSearchRequest {
    searchName?: string | undefined;
    preferredRequest?: PreferredSearchFilters;
    searchType?: PreferredSearchTypeEnum;
    notificationFrequency?: PreferredSearchNotificationFrequency;
}

export interface PreferredSearchResultCount {
    preferredSearchId?: string;
    resultCount?: number;
}

export enum PreferredSearchTypeEnum {
    Jobs = 1,
    Candidates = 2,
    Members = 3,
    CorporateCompanies = 4,
}

export interface PreferredSearchViewModel {
    id?: string;
    filters?: PreferredSearchFilters;
    userId?: string;
    createdDate?: Date;
    searchName?: string | undefined;
    preferredSearchType?: PreferredSearchTypeEnum;
}

export interface PreferredSearchViewModelPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: PreferredSearchViewModel[] | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export enum ProfileTypeEnum {
    Recruiter = 1,
    Corporate = 2,
}

export interface QualificationEntity {
    id?: number;
    name?: string | undefined;
}

export enum RateTypeEnum {
    Hourly = 1,
    Annual = 2,
}

export interface ReceivedPartnerInvitationStatusRequest {
    status?: InvitationStatusEnum;
}

export enum RecommendedCandidatesErrorEnum {
    Default = 0,
    PreferencesNotSpecified = 1,
    NoMatchingCandidates = 2,
}

export interface RecommendedCandidatesResponseModel {
    success?: boolean;
    errorType?: RecommendedCandidatesErrorEnum;
    candidates?: CandidateResponseModel[] | undefined;
    totalCount?: number;
}

export interface RegDataForExternalInvitationResponse {
    isActive: boolean;
    regData?: RegMarketplaceModel;
}

export interface RegInvitedUserModel {
    email?: string | undefined;
    password?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    secretKey?: string;
}

export interface RegMarketplaceModel {
    email?: string | undefined;
    password?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    companyName?: string | undefined;
    invitationId?: string | undefined;
}

export interface RepresentativeInfoModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
}

export interface RequestInterviewCandidateModel {
    dates?: DateTimeModel[] | undefined;
    type?: InterviewTypeEnum;
    notes?: string | undefined;
    jobCandidateId?: string;
    firstName?: string | undefined;
}

export interface ResourceDownloadResponse {
    /** File name to save */
    readonly fileName?: string | undefined;
    /** Url for get body of file from S3 via CloudFront */
    readonly downloadUrl: string;
    /** File key to save */
    readonly fileKey?: string | undefined;
}

export interface S3DownloadResponse {
    /** Url for get body of file from S3 via CloudFront */
    readonly downloadUrl: string;
}

export interface S3UploadResponse {
    /** S3Key for post model to BE */
    readonly s3Key: string;
    /** S3 required Header for upload */
    readonly contentType: string;
    /** Url for put body of file to S3 */
    readonly putUrl: string;
    /** Url for get body of file from S3 */
    readonly getUrl: string;
}

export interface SkillEntity {
    id?: number;
    name?: string | undefined;
}

export enum SortingEnum {
    Asc = 1,
    Desc = 2,
}

export interface StateEntity {
    id?: number;
    stateCode?: string | undefined;
    name?: string | undefined;
    countryId?: number;
}

export interface SubmissionsResponseModel {
    submissionsCount?: number;
    jobCount?: number;
    chartsData?: ChartsModel[] | undefined;
}

export interface SubmitCandidateModel {
    jobId?: string;
    candidateId?: string | undefined;
    newCandidate?: CandidateModel;
}

export interface SubmitCompanyCandidateModel {
    jobId?: string;
    candidateId?: string;
}

export interface TeammateModel {
    userId?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    role?: TeammateRoleEnum;
    status?: TeammateStatusEnum;
    invitationLink?: string | undefined;
}

export interface TeammateModelPagedResponseModel {
    totalCount?: number;
    pageNumber?: number;
    details?: TeammateModel[] | undefined;
}

export enum TeammateRoleEnum {
    TeammateAdmin = 1,
    TeammateRecruiter = 2,
    TeammateSubAdmin = 3,
}

export enum TeammateStatusEnum {
    Pending = 10,
    Active = 100,
    InActive = 200,
}

export interface TotalNumbersModel {
    todaysToDoTotalCount?: number;
    jobsTotalCount?: number;
    candidatesTotalCount?: number;
    partnersTotalCount?: number;
    teamTotalCount?: number;
}

export interface UnpublishJobReasonTypeEntity {
    id?: number;
    name?: string | undefined;
}

export interface UnpublishJobRequestModel {
    id?: string;
    reasonTypeId?: number;
    reasonValue?: string | undefined;
}

export interface UpdateDepartmentModel {
    departmentId?: string;
    name?: string | undefined;
    headDepartment?: string | undefined;
    headDepartmentEmail?: string | undefined;
    assignedRecruiter?: string | undefined;
}

export interface UpdateTeammateModel {
    userId?: string;
    roleId?: number;
}

export enum UserStatusEnum {
    InActive = 0,
    Active = 1,
    Deleted = -1,
}

export interface ViewsResponseModel {
    viewsCount?: number;
    jobCount?: number;
    chartsData?: ChartsModel[] | undefined;
}

export interface YearsExperienceEntity {
    id?: number;
    name?: string | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}